import { DeleteOutlined, ScanOutlined } from "@ant-design/icons";
import ArrowDropDownOutlinedIcon from "@mui/icons-material/ArrowDropDownOutlined";
import AutoFixHighSharpIcon from "@mui/icons-material/AutoFixHighSharp";
import CloseIcon from "@mui/icons-material/Close";
import ContactPhoneSharpIcon from "@mui/icons-material/ContactPhoneSharp";
import HistoryEduIcon from "@mui/icons-material/HistoryEdu";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { Button, Input, message } from "antd";
import axios from "axios";
import dayjs from "dayjs";
import html2pdf from "html2pdf.js";
import { Html5Qrcode } from "html5-qrcode";
import { QRCodeCanvas } from "qrcode.react";
import { useEffect, useRef, useState } from "react";
import noData from "../Assets/no-data-image.svg";
import { CREATE_jwel } from "../Config/Config";
import Header from "../Header";
import SidebarDrawer from "../SidebarDrawer";
import { printReceipt } from "../TopTen/eposPrint";
import styles from "./BarCodeScanner.module.css";
import { BillPdfDownload } from "./BillPdfDownload";
import CashMethod from "./CashMethod";
import CustomerInformation from "./CustomerInformation";
import HomeBillDialog from "./HomeBillDialog";
import ModifyInvoiceNo from "./ModifyInvoiceNo";
import SingleCardDetails from "./SingleCardDetails";
import TaansDetailsDialog from "./TaansDetailsDialog";
import WhatsAppDialog from "./WhatsAppDialog";
import OfferDetailsBDialog from "./OfferDetailsBDialog";
import OfferDetailsADialog from "./OfferDetailsADialog";
import EditItemDetails from "./EditItemDetails";
import CustomerDialog from "./CustomerDialog";

const BarCodeScanner = () => {
  const qrRef = useRef(null);
  const tagNoRef = useRef(null);
  const submitRef = useRef(null);
  const searchRef = useRef(null);
  const mobileRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [userArea, setUserArea] = useState();
  const [userName, setUserName] = useState();
  const [singleImage, setSingleImage] = useState();
  const [gstNo, setGstNo] = useState("");
  const [userPhone, setUserPhone] = useState("");
  const [conditions, setConditions] = useState("");
  const [ins, setIns] = useState("");
  const [ins1, setIns1] = useState("");
  const [ins2, setIns2] = useState("");
  const [ins3, setIns3] = useState("");
  const [ins4, setIns4] = useState("");
  const [ins5, setIns5] = useState("");
  const [ins6, setIns6] = useState("");
  const [address, setAddress] = useState("");
  const [address1, setAddress1] = useState("");
  const [city, setCity] = useState("");
  const [invoiceNo, setInvoiceNo] = useState(0);
  const [billDate, setBillDate] = useState();
  const [qrOpen, setQrOpen] = useState(false);
  const [scanOpen, setScanOpen] = useState(false);
  const [scanResult, setScanResult] = useState("");
  const [scanner, setScanner] = useState(null);
  const [barCodeData, setBarCodeData] = useState([]);
  const [updatedData, setUpdatedData] = useState([]);
  const [totalQty, setTotalQty] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [totalDisAmt, setTotalDisAmt] = useState(0);
  const [totalNetAmt, setTotalNetAmt] = useState(0);
  const [gstData, setGstData] = useState([]);
  const [customerArea, setCustomerArea] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [customerMobile, setCustomerMobile] = useState("");
  const [customerOpen, setCustomerOpen] = useState(false);
  const [cardOpen, setCardOpen] = useState(false);
  const [titleValue, setTitleValue] = useState("");
  const [gst, setGst] = useState(0);
  const [gstAmt, setGstAmt] = useState(0);
  const [cGstRate, setCGstRate] = useState(0);
  const [cGstAmt, setCGstAmt] = useState(0);
  const [sGstRate, setSGstRate] = useState(0);
  const [sGstAmt, setSGstAmt] = useState(0);
  const [iGstRate, setIGstRate] = useState(0);
  const [iGstAmt, setIGstAmt] = useState(0);
  const [basicAmt, setBasicAmt] = useState(0);
  const [netAmt, setNetAmt] = useState(0);
  const [smCode, setSmCode] = useState("");
  const [totalBasicAmount, setTotalBasicAmount] = useState(0);
  const [totalGstAmt, setTotalGstAmt] = useState(0);
  const [totalCGSTAmt, setTotalCGSTAmt] = useState(0);
  const [totalSGSTAmt, setTotalSGSTAmt] = useState(0);
  const [totalDiscount, setTotalDiscount] = useState(0);
  const [modifyOpen, setModifyOpen] = useState(false);
  const [modifyCode, setModifyCode] = useState();
  const [cashOpen, setCashOpen] = useState(false);
  const [cashValue, setCashValue] = useState("CASH");
  const [cashAmt, setCashAmt] = useState(0);
  const [cardAmt, setCardAmt] = useState(0);
  const [upiAmt, setUpiAmt] = useState(0);
  const [onlineAmt, setOnlineAmt] = useState(0);
  const [creditAmt, setCreditAmt] = useState(0);
  const [totalGstData, setTotalGstData] = useState([]);
  const [cardAcc, setCardAcc] = useState("");
  const [upiAcc, setUpiAcc] = useState("");
  const [onlineAcc, setOnlineAcc] = useState("");
  const [switchCredit, setSwitchCredit] = useState("Cash");
  const [creditCashValue, setCreditCashValue] = useState("CREDIT");
  const [creditCashAmt, setCreditCashAmt] = useState(0);
  const [creditCardAmt, setCreditCardAmt] = useState(0);
  const [creditUpiAmt, setCreditUpiAmt] = useState(0);
  const [creditOnlineAmt, setCreditOnlineAmt] = useState(0);
  const [invNo, setInvNo] = useState(0);
  const [base64, setBase64] = useState();
  const [whatsAppOpen, setWhatsAppOpen] = useState(false);
  const [whatsAppCheck, setWhatsAppCheck] = useState(false);
  const [base64Images, setBase64Images] = useState();
  const [base64QR, setBase64QR] = useState("");
  const [homeDetailsOpen, setHomeDetailsOpen] = useState(false);
  const [productData, setProductData] = useState([]);
  const [qty, setQty] = useState(0);
  const [amount, setAmount] = useState(0);
  const [disCount, setDisCount] = useState(0);
  const [rate, setRate] = useState(0);
  const [disAmt, setDisAmt] = useState(0);
  const [productName, setProductName] = useState("");
  const [designCode, setDesignCode] = useState("");
  const [pTypeName, setPTypeName] = useState("");
  const [brandName, setBrandName] = useState("");
  const [hsnCode, setHsnCode] = useState("");
  const [taansOpen, setTaansOpen] = useState(false);
  const [taansData, setTaansData] = useState([]);
  const [qtyData, setQtyData] = useState([]);
  const [offerAOpen, setOfferAOpen] = useState(false);
  const [offerAData, setOfferAData] = useState([]);
  const [offerARate, setOfferARate] = useState(0);
  const [offerBOpen, setOfferBOpen] = useState(false);
  const [offerBData, setOfferBData] = useState([]);
  const [offerBRate, setOfferBRate] = useState(0);
  const [itemDetailsOpen, setItemDetailsOpen] = useState(false);
  const [itemDetailsData, setItemDetailsData] = useState({});
  const [itemDesignCode, setItemDEsignCode] = useState();
  const [messageApi, contextHolder] = message.useMessage();
  const [userDetails, setUserDetails] = useState({});
  const [phoneNo, setPhoneNo] = useState();
  const [cPhoneNo, setCPhoneNo] = useState();
  const [custOpen, setCustOpen] = useState(false);
  const [comm, setComm] = useState(0);
  const [prvBalance, setPrvBalance] = useState(0);
  const [formValues, setFormValues] = useState({
    mobile1: "",
    city: "",
    name: "",
    mobile2: "",
    phone: "",
    address1: "",
    address2: "",
    address3: "",
    address4: "",
    state: "ANDHRA PRADESH",
    stateCode: "37",
    gstin: "",
    panNo: "",
    idProof: "",
    dob: "",
    anniversary: "",
    locationType: "LOCAL",
  });

  const tenantName = localStorage.getItem("tenantName");
  const pdfModule = localStorage.getItem("pdfModule");
  const localIp = localStorage.getItem("ipAddress");
  const loginName = localStorage.getItem("loginName");

  const isValidValue = (val) => {
    return (
      val !== null &&
      val !== undefined &&
      val !== "-" &&
      String(val).trim() !== "" &&
      String(val) !== "undefined"
    );
  };

  const totalAmt = totalNetAmt - cardAmt - upiAmt - onlineAmt - creditAmt;
  const invPaidAmt = totalNetAmt - creditAmt;

  const upiId = "Q021547713@ybl";

  const upiLink = `upi://pay?pa=${upiId}&am=${totalNetAmt}&cu=INR`;

  const toggleDrawer = () => setOpen(false);

  const invoiceCountAPI = async () => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetMaxNumberInTable?tableName=CREDIT_BILLMAST&column=BILLNO`,
        {
          headers: {
            tenantName: tenantName,
          },
        }
      );

      const data = response.data;

      // if (Array.isArray(data) && data.length > 0) {
      //   setInvoiceNo(data[0].Column1);
      // }
      if (Array.isArray(data) && data.length > 0) {
        const rawValue = data[0]?.Column1;
        const maxInvNo = Number.isFinite(Number(rawValue))
          ? Number(rawValue)
          : 0;
        const newInvNo = maxInvNo + 1;
        setInvoiceNo(newInvNo);
        return newInvNo;
      }
    } catch (error) {
      console.error("Error fetching estimation count:", error);
    }
  };

  const onlineAccNoAPI = async () => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetDataFromGivenTableName?tableName=ONLINEMODE_MAST`,
        {
          headers: {
            tenantName: tenantName,
          },
        }
      );

      const data = response.data;

      if (Array.isArray(data) && data.length > 0) {
        const card = data.find((item) => item.PTYPE === "CARD");
        const upi = data.find((item) => item.PTYPE === "UPI");
        const online = data.find((item) => item.PTYPE === "ONLINE");

        if (card) setCardAcc(card.accno);
        if (upi) setUpiAcc(upi.accno);
        if (online) setOnlineAcc(online.accno);
      }
    } catch (error) {
      console.error("Error fetching estimation count:", error);
    }
  };

  const userGetDetailsAPI = async (value) => {
    const mobileValue = isValidValue(value) ? value : phoneNo;

    if (!isValidValue(mobileValue)) {
      console.log("Invalid mobile number. API not called.");
      return;
    }
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetDataFromGivenTableNameWithWhere?tableName=CUSTOMER&where=MOBILENO='${
          value ? value : phoneNo
        }'`,
        {
          headers: {
            tenantName: tenantName,
          },
        }
      );

      const data = response.data;

      if (Array.isArray(data) && data.length > 0) {
        setUserDetails(data[0]);
        setFormValues({
          mobile1: data[0]?.Mobileno || "",
          city: data[0]?.Area || "",
          name: data[0]?.Custname || "",
          mobile2: data[0]?.Phoneno || "",
          phone: data[0]?.Phoneno || "",
          address1: data[0]?.add1 || "",
          address2: data[0]?.add2 || "",
          address3: data[0]?.add3 || "",
          address4: data[0]?.add4 || "",
          state: data[0]?.STATE || "ANDHRA PRADESH",
          stateCode: data[0]?.STATECODE || "37",
          gstin: data[0]?.TINNO || "-",
          panNo: "",
          idProof: "",
          dob: data[0]?.dob || "",
          anniversary: data[0]?.ANNVERSARY || "",
          locationType: data[0]?.STATION || "LOCAL",
        });
        setPhoneNo();
      }
    } catch (error) {
      console.error("Error fetching estimation count:", error);
    }
  };

  const userDetailsAPI = async (value) => {
    const mobileValue = isValidValue(value) ? value : phoneNo;

    if (!isValidValue(mobileValue)) {
      console.log("Invalid mobile number. API not called.");
      return;
    }
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetDataFromGivenTableNameWithWhere?tableName=CUSTOMER&where=MOBILENO='${
          value ? value : phoneNo
        }'`,
        {
          headers: {
            tenantName: tenantName,
          },
        }
      );

      const data = response.data;

      if (Array.isArray(data) && data.length > 0) {
        setUserDetails(data[0]);
        setCPhoneNo(data[0]?.Mobileno);
        OpeningLedgerBalanceAPI(data[0]?.Mobileno, data[0]?.Custname);
        setFormValues({
          mobile1: data[0]?.Mobileno || "",
          city: data[0]?.Area || "",
          name: data[0]?.Custname || "",
          mobile2: data[0]?.Phoneno || "",
          phone: data[0]?.Phoneno || "",
          address1: data[0]?.add1 || "",
          address2: data[0]?.add2 || "",
          address3: data[0]?.add3 || "",
          address4: data[0]?.add4 || "",
          state: data[0]?.STATE || "ANDHRA PRADESH",
          stateCode: data[0]?.STATECODE || "37",
          gstin: data[0]?.TINNO || "-",
          panNo: "",
          idProof: "",
          dob: data[0]?.dob || "",
          anniversary: data[0]?.ANNVERSARY || "",
          locationType: data[0]?.STATION || "LOCAL",
        });
        setPhoneNo();
      } else {
        setOpen(true);
        setUserDetails({});
        setFormValues({
          mobile1: phoneNo,
          city: "",
          name: "",
          mobile2: "",
          phone: "",
          address1: "",
          address2: "",
          address3: "",
          address4: "",
          state: "ANDHRA PRADESH",
          stateCode: "37",
          gstin: "",
          panNo: "",
          idProof: "",
          dob: "",
          anniversary: "",
          locationType: "LOCAL",
        });
      }
    } catch (error) {
      console.error("Error fetching estimation count:", error);
    }
  };

  const gstCheckAPI = async () => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetDataFromGivenTableName?tableName=PURCHASE_TYPE`,
        {
          headers: {
            tenantName: tenantName,
          },
        }
      );

      const data = response.data;

      if (Array.isArray(data) && data.length > 0) {
        setGstData(data);
      }
    } catch (error) {
      console.error("Error fetching estimation count:", error);
    }
  };

  const qtyAPI = async (no) => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetDataFromGivenTableNameWithWhere?tableName=CURRENT_STOCK&where=DESIGNCODE='${no}'`,
        {
          headers: {
            tenantName: tenantName,
          },
        }
      );

      const data = response.data;

      // if (response.status === 200) {
      //   setScanResult("");
      // }

      setQtyData((prev) => {
        // Filter out items that already exist
        const filteredNewItems = data
          .filter(
            (item) =>
              !prev.some((prevItem) => prevItem.DesignCode === item.DesignCode)
          )
          .map((item) => ({
            DesignCode: item.DesignCode,
            Qty: item.Qty,
          }));

        // Combine previous state with new items

        return [...prev, ...filteredNewItems];
      });
    } catch (error) {
      console.error("Error fetching estimation count:", error);
    }
  };

  const commissionAPI = async () => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetDataFromGivenTableName?tableName=CONFIGURE`,
        {
          headers: {
            tenantName: tenantName,
          },
        }
      );

      const data = response.data;

      if (Array.isArray(data) && data.length > 0) {
        setComm(data[0]?.COMM);
      }
    } catch (error) {
      console.error("Error fetching estimation count:", error);
    }
  };

  const mainAPI = async (tagNo) => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetDataFromGivenTableNameWithWhere?tableName=CURRENT_STOCK&where=DESIGNCODE='${
          scanResult ? scanResult : tagNo
        }'`,
        {
          headers: {
            tenantName: tenantName,
          },
        }
      );

      const data = response.data;

      if (response.status === 200) {
        setScanResult("");
      }
      if (!Array.isArray(data) || data.length === 0) {
        setScanResult();
        messageApi.open({
          type: "error",
          content: (
            <div style={{ fontSize: "20px" }}>Design Code Not existed</div>
          ),
        });
        return;
      }
      let newQtyData = [...qtyData]; // start with existing state
      const alreadyExists = newQtyData.some(
        (item) => item.DesignCode === data[0]?.DesignCode
      );

      if (!alreadyExists) {
        newQtyData = [
          ...newQtyData,
          ...data.map((item) => ({
            DesignCode: item?.DesignCode,
            Qty: item?.Qty,
          })),
        ];
      }

      // Update qtyData state
      setQtyData(newQtyData);
      if (data[0]?.taans === true) {
        setTaansOpen(true);
        setTaansData(
          data.map((item) => ({
            ...item,
            stock: 0, // editable quantity
          }))
        );
        return;
      }
      if (data[0]?.SMODEL === "A") {
        setOfferAOpen(true);
        setOfferARate(data[0]?.CPrice);
        setOfferAData(
          data.map((item) => ({
            ...item,
            stock: 3, // editable quantity
            CPrice: data[0]?.OQTY3 / 3,
            offer: data[0]?.OQTY3 / 3,
          }))
        );
        return;
      }
      if (data[0]?.SMODEL === "B") {
        setOfferBOpen(true);
        setOfferBRate(data[0]?.Disper);
        setOfferBData(
          data.map((item) => ({
            ...item,
            stock: 3, // editable quantity
            Disper: data[0]?.OQTY3,
            disAmt: (data[0]?.CPrice * data[0]?.OQTY3) / 100,
            offer: data[0]?.CPrice - (data[0]?.CPrice * data[0]?.OQTY3) / 100,
          }))
        );
        return;
      }
      handlePdfDownload();
      // setBarCodeData((prevData) => {
      //   // const existingTag = prevData.some(
      //   //   (item) => item.DesignCode === scanResult
      //   // );
      //   // if (existingTag) {
      //   //   message.error("Already Existed This Design Code");
      //   //   return prevData;
      //   // }

      //   const updatedData = [
      //     ...prevData,
      //     ...data.map((item) => {
      //       const gstItem = gstData.find((gst) => gst.PType === item.PTYPE);

      //       let appliedGST = 0;

      //       if (gstItem?.ALLOWGSTVALUE === true) {
      //         const offerAmount = item.offer ?? 0;

      //         if (offerAmount <= gstItem.BELLOWVALUE) {
      //           appliedGST = gstItem.BELLOWPER;
      //         } else if (offerAmount >= gstItem.ABOVEVALUE) {
      //           appliedGST = gstItem.ABOVEPER;
      //         }
      //       } else {
      //         appliedGST = item?.GST;
      //       }

      //       return {
      //         ...item,
      //         stock: 1,
      //         GSTApplied: appliedGST,
      //       };
      //     }),
      //   ];

      //   const totalBasic = updatedData.reduce((acc, item) => {
      //     const offer = Number(item.offer) || 0;
      //     const qty = Number(item.stock) || 0;
      //     const gst = Number(item.GSTApplied) || 0;
      //     const netAmt = qty * offer;
      //     return acc + netAmt * (100 / (100 + gst));
      //   }, 0);
      //   setTotalBasicAmount(totalBasic);

      //   const totalGst = updatedData.reduce((acc, item) => {
      //     const offer = Number(item.offer) || 0;
      //     const qty = Number(item.stock) || 0;
      //     const gst = Number(item.GSTApplied) || 0;
      //     const netAmt = qty * offer;
      //     const basic = netAmt * (100 / (100 + gst));
      //     return acc + basic * (gst / 100);
      //   }, 0);
      //   setTotalGstAmt(totalGst);

      //   const totalCGST = updatedData.reduce((acc, item) => {
      //     const offer = Number(item.offer) || 0;
      //     const qty = Number(item.stock) || 0;
      //     const gst = Number(item?.GSTApplied) || 0;
      //     const netAmt = qty * offer;
      //     const value = netAmt * (100 / (100 + gst));
      //     return acc + (value * (gst / 100)) / 2;
      //   }, 0);
      //   setTotalCGSTAmt(totalCGST);

      //   const totalSGST = updatedData.reduce((acc, item) => {
      //     const offer = Number(item.offer) || 0;
      //     const qty = Number(item.stock) || 0;
      //     const gst = Number(item?.GSTApplied) || 0;
      //     const netAmt = qty * offer;
      //     const value = netAmt * (100 / (100 + gst));
      //     return acc + (value * (gst / 100)) / 2;
      //   }, 0);
      //   setTotalSGSTAmt(totalSGST);
      //   const totalDis = updatedData.reduce((acc, item) => {
      //     const dis = Number(item.Disper) || 0;
      //     return acc + dis;
      //   }, 0);
      //   setTotalDiscount(totalDis);

      //   const gstGroupedMap = new Map();

      //   updatedData.forEach((item) => {
      //     const key = item.GSTApplied;
      //     const netAmt = item.stock * item.offer;
      //     const basicAmt = netAmt * (100 / (100 + key));
      //     const cgstRate = key / 2;
      //     const cgstAmt = (netAmt * (key / 100)) / 2;
      //     const sgstAmt = cgstAmt;

      //     if (!gstGroupedMap.has(key)) {
      //       gstGroupedMap.set(key, {
      //         GST: key,
      //         CGST_RATE: cgstRate,
      //         Basic_amt: 0,
      //         CGST_AMT: 0,
      //         SGST: cgstRate,
      //         SGST_AMT: 0,
      //         NET_AMT: 0,
      //       });
      //     }

      //     const existing = gstGroupedMap.get(key);
      //     existing.Basic_amt += basicAmt;
      //     existing.CGST_AMT += cgstAmt;
      //     existing.SGST_AMT += sgstAmt;
      //     existing.NET_AMT += netAmt;
      //   });

      //   const gstAmtData = Array.from(gstGroupedMap.values());
      //   setTotalGstData(gstAmtData);

      //   return updatedData;
      // });
      setBarCodeData((prevData) => {
        let updatedData = [...prevData];

        data.forEach((newItem) => {
          const designCode = newItem.DesignCode;

          // 🔍 Find qty limit from newQtyData
          const qtyInfo = newQtyData.find((q) => q.DesignCode === designCode);

          if (!qtyInfo || Number(qtyInfo.Qty) === 0) {
            messageApi.open({
              type: "error",
              content: (
                <span style={{ fontSize: "18px", fontWeight: 600 }}>
                  Qty is zero for ${designCode}.
                </span>
              ),
            });
            // message.error(`Qty is zero for ${designCode}`);
            return;
          }

          const maxQty = Number(qtyInfo.Qty);

          // 🔍 Count total existing quantity for this DesignCode in updatedData
          const existingTotalQty = updatedData
            .filter((item) => item.DesignCode === designCode)
            .reduce((sum, item) => sum + (Number(item.stock) || 0), 0);

          // ❌ If total qty reached, don't add new entry
          if (existingTotalQty >= maxQty) {
            messageApi.open({
              type: "error",
              content: (
                <span style={{ fontSize: "18px", fontWeight: 600 }}>
                  Qty limit reached for ${designCode}.
                </span>
              ),
            });
            // message.error(`Qty limit reached for ${designCode}`);
            return;
          }

          // 🆕 Add new entry with stock = 1
          const gstItem = gstData.find((gst) => gst.PType === newItem.PTYPE);

          let appliedGST = 0;
          if (gstItem?.ALLOWGSTVALUE === true) {
            const offerAmount = newItem.offer ?? 0;
            if (offerAmount <= gstItem.BELLOWVALUE) {
              appliedGST = gstItem.BELLOWPER;
            } else if (offerAmount >= gstItem.ABOVEVALUE) {
              appliedGST = gstItem.ABOVEPER;
            }
          } else {
            appliedGST = newItem?.GST;
          }

          updatedData.push({
            ...newItem,
            stock: 1,
            GSTApplied: appliedGST,
          });
        });

        // ===== TOTAL CALCULATIONS =====
        const totalBasic = updatedData.reduce((acc, item) => {
          const offer = Number(item.offer) || 0;
          const qty = Number(item.stock) || 0;
          const gst = Number(item.GSTApplied) || 0;
          const netAmt = qty * offer;
          return acc + netAmt * (100 / (100 + gst));
        }, 0);
        setTotalBasicAmount(totalBasic);

        const totalGst = updatedData.reduce((acc, item) => {
          const offer = Number(item.offer) || 0;
          const qty = Number(item.stock) || 0;
          const gst = Number(item.GSTApplied) || 0;
          const netAmt = qty * offer;
          const basic = netAmt * (100 / (100 + gst));
          return acc + basic * (gst / 100);
        }, 0);
        setTotalGstAmt(totalGst);

        const totalCGST = totalGst / 2;
        const totalSGST = totalGst / 2;
        setTotalCGSTAmt(totalCGST);
        setTotalSGSTAmt(totalSGST);

        const totalDis = updatedData.reduce((acc, item) => {
          const dis = Number(item.Disper) || 0;
          return acc + dis;
        }, 0);
        setTotalDiscount(totalDis);

        // ===== GST GROUP =====
        const gstGroupedMap = new Map();

        updatedData.forEach((item) => {
          const key = item.GSTApplied;
          const netAmt = item.stock * item.offer;
          const basicAmt = netAmt * (100 / (100 + key));
          const cgstRate = key / 2;
          const cgstAmt = (netAmt * (key / 100)) / 2;
          const sgstAmt = cgstAmt;

          if (!gstGroupedMap.has(key)) {
            gstGroupedMap.set(key, {
              GST: key,
              CGST_RATE: cgstRate,
              Basic_amt: 0,
              CGST_AMT: 0,
              SGST: cgstRate,
              SGST_AMT: 0,
              NET_AMT: 0,
            });
          }

          const existing = gstGroupedMap.get(key);
          existing.Basic_amt += basicAmt;
          existing.CGST_AMT += cgstAmt;
          existing.SGST_AMT += sgstAmt;
          existing.NET_AMT += netAmt;
        });

        const gstAmtData = Array.from(gstGroupedMap.values());
        setTotalGstData(gstAmtData);

        return updatedData;
      });
    } catch (error) {
      console.error("Error fetching estimation count:", error);
    }
  };

  const homeBillData = async (tagNo) => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetDataFromGivenTableNameWithWhere?tableName=PRODUCT_MASTER&where=SHORTKEY='${
          scanResult ? scanResult : tagNo
        }'`,
        {
          headers: {
            tenantName: tenantName,
          },
        }
      );

      const data = response.data;

      if (!Array.isArray(data) || data.length === 0) {
        setScanResult();
        // message.warning("Design Code Not existed");
        // message.open({
        //   type: "error",
        //   content: (
        //     <div style={{ fontSize: "20px" }}>Design Code Not existed</div>
        //   ),
        // });
        return;
      }
      setScanResult();
      setProductData(data);
      // setRate(data[0]?.MRP);
      // setProductName(data[0]?.PRODNAME);
      setDesignCode(data[0]?.SHORTKEY);
      // setPTypeName(data[0]?.PTYPE);
      // setHsnCode(data[0]?.HSNCODE);
      // setBrandName(data[0].BRANDNAME);
      setHomeDetailsOpen(true);
    } catch (error) {
      console.error(error);
    }
  };

  const OpeningLedgerBalanceAPI = async (phone, name) => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetDataFromGivenTableNameWithWhere?tableName=TRANS_ENTRY_DATA_CUST&where=AGENTNAME='${phone}' AND PARTYNAME='${name}'`,
        {
          headers: {
            tenantName: tenantName,
          },
        }
      );
      const data = response.data;
      if (Array.isArray(data) && data.length > 0) {
        const nama = data.reduce(
          (acc, item) => acc + (Number(item.NAMA) || 0),
          0
        );
        const jama = data.reduce(
          (acc, item) => acc + (Number(item.JAMA) || 0),
          0
        );
        const balanceCash = nama - jama;
        setPrvBalance(balanceCash);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const date = new Date();
  date.setUTCHours(0, 0, 0, 0);
  const billNoDate = new Date(
    dayjs(billDate).startOf("day").format("YYYY-MM-DD")
  ).toISOString();

  const createBarcodeData = async (inv) => {
    const requestBody = barCodeData.map((item, index) => {
      const basicAmt =
        item.stock * item.offer * (100 / (100 + item.GSTApplied));
      const commValue = Number(item.stock * item.offer);
      const commission = (commValue * comm) / 100;
      const commToken = item?.TOKEN > 0 ? 0 : commission;
      return {
        billno: invNo ? invNo : inv,
        billdate: billDate
          ? dayjs(billDate).format("YYYY-MM-DD")
          : dayjs().format("YYYY-MM-DD"), // current timestamp in ISO format
        street: userDetails?.Area || "-",
        custName: userDetails?.Custname || "-",
        sno: index + 1,
        itemcode: item?.DesignCode,
        itemname: item?.ProdName,
        code: item?.Code,
        compName: item?.CompName,
        groupName: item?.GroupName,
        smcode: "-",
        qty: item?.stock,
        rate: item?.CPrice,
        disper: item?.Disper,
        disAmt: item?.Disamt,
        actrate: item?.offer,
        amount: item?.offer * item?.stock,
        hid: item?.HID,
        dPrice: item?.DPrice,
        comm: Number(commToken),
        token: item?.TOKEN,
        ptype: item?.PTYPE,
        area: item?.Area,
        partyname: item?.Partyname,
        vatper: 0,
        vatamt: 0,
        floor: item?.FLOOR,
        estno: "-",
        station: "mobile",
        hsncode: item?.HSNCODE,
        gst: item?.GSTApplied,
        gstamt: basicAmt * (item?.GSTApplied / 100),
        cgstrate: item?.GSTApplied / 2,
        cgstamt: (basicAmt * (item?.GSTApplied / 100)) / 2,
        sgstrate: item?.GSTApplied / 2,
        sgstamt: (basicAmt * (item?.GSTApplied / 100)) / 2,
        igstrate: item?.IGSTRATE,
        igstamt: item?.IGSTAMT,
        basicamt: Number(basicAmt) ?? 0,
        serialno: 0,
        brandcode: "0",
        salestype: "BILLING",
        prodsize: item?.Prodsize,
        fsize: "-",
        tsize: "-",
        differ: "-",
        actqty: item?.stock,
        refcode: "-",
        boxes: 0,
        loosepcs: 0,
        pfcharges: 0,
        cessper: 0,
        cessamt: 0,
        packpcs: 0,
        caseprice: 0,
        pcsprice: 0,
        casepricers: 0,
        pcspricers: 0,
        measurementtype: "-",
        tokenper: item?.TOKEN,
        ustatus: false,
        estbillno: false,
        cloud_upload: true,
      };
    });
    try {
      const response = await axios.post(
        `${CREATE_jwel}/api/ERP/InsertCreditBillData`,
        requestBody,
        {
          headers: {
            "Content-Type": "application/json",
            tenantName: tenantName,
          },
        }
      );
      let data = response?.data;
      if (response?.status === 200) {
        // invoiceCountAPI();
        // handleRest();
        // setCashValue("CASH");
        // setCardAmt(0);
        // setUpiAmt(0);
        // setOnlineAmt(0);
        // setCreditCashValue("CREDIT");
        // setSwitchCredit("Cash");
      }
    } catch (error) {
      console.error("Error posting data:", error);
    }
  };

  const createBarcodeDet = async (inv) => {
    const requestBody = barCodeData.map((item, index) => {
      const basicAmt =
        item.stock * item.offer * (100 / (100 + item.GSTApplied));
      const rate =
        item?.SMODEL === "A"
          ? offerARate
          : item?.SMODEL === "B"
          ? offerBRate
          : 0;
      const commValue = Number(item.stock * item.offer);
      const commission = (commValue * comm) / 100;
      const commToken = item?.TOKEN > 0 ? 0 : commission;
      return {
        billno: invNo ? invNo : inv,
        billdate: billDate
          ? dayjs(billDate).format("YYYY-MM-DD")
          : dayjs().format("YYYY-MM-DD"), // current timestamp in ISO format
        street: userDetails?.Area || "-",
        custName: userDetails?.Custname || "-",
        sno: index + 1,
        itemcode: item?.DesignCode,
        itemname: item?.ProdName,
        code: item?.Code,
        compName: item?.CompName,
        groupName: item?.GroupName,
        smcode: "-",
        qty: item?.stock,
        rate: item?.CPrice,
        disper: item?.Disper,
        disAmt: item?.Disamt,
        actrate: String(item?.offer ?? ""),
        amount: String(item?.offer * item?.stock ?? ""),
        hid: item?.HID,
        dPrice: item?.DPrice,
        comm: Number(commToken) ?? 0,
        token: item?.TOKEN,
        ptype: item?.PTYPE,
        area: item?.Area,
        partyname: item?.Partyname,
        type: "B",
        vatper: 0,
        vatamt: 0,
        floor: item?.FLOOR,
        wsalebill: false,
        appno: 0,
        invno: item?.InvNO,
        invdate: billDate
          ? dayjs(billDate).format("YYYY-MM-DD")
          : dayjs().format("YYYY-MM-DD"),
        colour: item?.COLOUR,
        fitting: item?.FITTING,
        sleves: item?.SLEVES,
        ecode: item?.ECODE,
        prodsize: item?.Prodsize,
        station: String(item?.SMODEL) ?? "",
        iteM_DIS: item?.Disamt,
        iteM_ACTRATE: item?.offer,
        scheck: false,
        hsncode: item?.HSNCODE,
        gst: item?.GSTApplied,
        gstamt: basicAmt * (item?.GSTApplied / 100),
        cgstrate: item?.GSTApplied / 2,
        cgstamt: (basicAmt * (item?.GSTApplied / 100)) / 2,
        sgstrate: item?.GSTApplied / 2,
        sgstamt: (basicAmt * (item?.GSTApplied / 100)) / 2,
        igstrate: 0,
        igstamt: 0,
        basicamt: Number(basicAmt) ?? 0,
        serialno: 0,
        brandcode: "0",
        salestype: "BILLING",
        fsize: "-",
        tsize: "-",
        differ: "-",
        actqty: item?.stock,
        refcode: "-",
        state: "-",
        statecode: "-",
        tinno: "-",
        idproof: "-",
        panno: "-",
        boxes: item?.BOXES || 0,
        loosepcs: item?.LOOSEPCS || 0,
        pfcharges: 0,
        cessper: Number(rate),
        cessamt: 0,
        packpcs: item?.PACKPCS || 0,
        caseprice: Number(item?.OQTY3),
        pcsprice: Number(item?.OQTY2),
        casepricers: 0,
        pcspricers: 0,
        measurementtype: "-",
        tokenper: 0,
        ustatus: false,
        gstin: "-",
        estbillno: false,
        cloud_upload: true,
      };
    });
    try {
      const response = await axios.post(
        `${CREATE_jwel}/api/ERP/InsertBillItemsDet`,
        requestBody,
        {
          headers: {
            "Content-Type": "application/json",
            tenantName: tenantName,
          },
        }
      );
      let data = response?.data;
      if (response?.status === 200) {
        // invoiceCountAPI();
        // handleRest();
        // setCashValue("CASH");
        // setCardAmt(0);
        // setUpiAmt(0);
        // setOnlineAmt(0);
        // setCreditCashValue("CREDIT");
        // setSwitchCredit("Cash");
      }
    } catch (error) {
      console.error("Error posting data:", error);
    }
  };

  const createBarcodeMast = async (inv) => {
    const requestBody = {
      billno: invNo ? Number(invNo) : Number(inv),
      billdate: billDate ? billNoDate : date.toISOString(),
      street: String(userDetails?.Area || "-"),
      custName: String(userDetails?.Custname || "-"),
      add1: userDetails?.add1 || "-",
      phoneNo: String(userDetails?.Mobileno || "-"),
      totamt: Number(totalAmount),
      discount: Number(totalDisAmt),
      advAmt: Number(cashAmt),
      finalamt: Number(creditAmt),
      billtype: cashValue === "CREDIT" ? "CREDIT" : "CASH",
      lessAmt: 0,
      smcode: "-",
      pstatus: false,
      ebillno: 0,
      mode:
        cashValue === "CREDIT"
          ? "CASH"
          : cashValue === "CASH"
          ? "CASH"
          : "CARD",
      accNO: "-",
      cardno: cashValue === "CREDIT" ? "0" : cashValue === "CASH" ? "0" : "-",
      cardamt: Number(cardAmt || upiAmt || onlineAmt || 0),
      sTax: 0,
      flrcode: "-",
      esmCode: "-",
      days: 0,
      cStatus: true,
      card: 0,
      hid: 0,
      estno: 0,
      adD2: userDetails?.add2 || "-",
      billtime: billDate ? billNoDate : date,
      uname: String(loginName) || "-",
      cancell: "NO",
      ctime: billDate ? billNoDate : date,
      cuname: "-",
      station: "mobile",
      billstatus: false,
      funame: "-",
      fstation: "-",
      reccash: 0,
      refcash: 0,
      wsalebill: false,
      appno: 0,
      ccause: "-",
      edisamt: 0,
      chqdate: billDate ? billNoDate : date.toISOString(),
      narration: "-",
      invpayableamt: Number(totalNetAmt),
      invpaidamt: Number(invPaidAmt),
      invrtnamt: 0,
      invbalamt: Number(creditAmt),
      invstatus: true,
      extradiscount: 0,
      prevpoints: 0,
      prevamt: 0,
      billpoints: 0,
      billvalue: 0,
      redimpoints: 0,
      redimamt: 0,
      totpoints: 0,
      totvalue: 0,
      prevcardno: "-",
      adjustments: 0,
      totgst: 0,
      totogstamt: Number(totalGstAmt),
      totcgstrate: 0,
      totcgstamt: Number(totalCGSTAmt),
      totsgstrate: 0,
      totsgstamt: Number(totalSGSTAmt),
      totigstrate: 0,
      totigstamt: 0,
      serialno: 0,
      salestype: "BILLING",
      custstation: "-",
      transport: "-",
      custtype: "CUSTOMER",
      stype: "BILLING",
      lrno: "-",
      lrdate: "-",
      shipstreet: "-",
      shipcustname: "-",
      shipadD1: "-",
      shipadD2: "-",
      shipphoneno: "-",
      shiptinno: "-",
      noofbags: "-",
      orderno: "-",
      orderdate: "-",
      dateofsupply: "-",
      placeofsupply: "-",
      company: "-",
      place: "-",
      branch: "-",
      bankaccno: "-",
      ifsccode: "-",
      state: "-",
      statecode: "-",
      shipstate: "-",
      shipstatecode: "-",
      bankname: "-",
      beatarea: "-",
      orddate: "-",
      gstin: "-",
      totbasicamt: Number(totalBasicAmount),
      totamtaftax: 0,
      salesper: 0,
      salesamt: 0,
      grossamt: Number(totalNetAmt),
      roundoff: 0,
      netamt: Number(totalNetAmt),
      tinno: "-",
      idproof: "-",
      panno: "-",
      purchno: "-",
      disamt: 0,
      schemeamt: 0,
      disper: 0,
      pinvno: "-",
      m_BTYPE: "-",
      m_BNO: "-",
      m_BDATE: "-",
      includinggst: false,
      acity: "-",
      agentname: "-",
      ustatus: false,
      estbillno: false,
      paymode: "-",
      totqty: totalQty,
      refundamt: 0,
      paidcard: Number(cardAmt),
      paidcheque: 0,
      paidonline: Number(onlineAmt),
      paidupi: Number(upiAmt),
      paidcash: Number(cashAmt),
      balance: Number(creditAmt),
      ctype: "RETAIL",
      withgst: false,
      marginper: 0,
      cloud_upload: true,
      couponredem: 0,
    };
    try {
      const response = await axios.post(
        `${CREATE_jwel}/api/ERP/InsertCreditBillMast`,
        requestBody,
        {
          headers: {
            "Content-Type": "application/json",
            tenantName: tenantName,
          },
        }
      );
      let data = response?.data;
      if (response?.status === 200) {
        invoiceCountAPI();
        commissionAPI();
        handleRest();
        setCashValue("CASH");
        setCardAmt(0);
        setUpiAmt(0);
        setOnlineAmt(0);
        setCreditCashValue("CREDIT");
        setSwitchCredit("Cash");
      }
    } catch (error) {
      console.error("Error posting data:", error);
    }
  };

  const createLedgerBalanceAPI = async (inv) => {
    const requestBody = [
      {
        area: userDetails?.Area ?? "-",
        partyname: userDetails?.Custname ?? "-",
        billno: invNo ? String(invNo) : String(inv),
        billdate: billDate ? billNoDate : date.toISOString(),
        entryno: invNo ? invNo : inv,
        entrydate: billDate ? billNoDate : date.toISOString(),
        particulars: "-",
        jamaqty: 0,
        namaqty: totalQty ?? 0,
        jama: 0,
        nama: creditAmt ?? 0,
        narration: "-",
        hid: 0,
        agentcity: "-",
        agentname: String(userDetails?.Mobileno) ?? "-",
        tranS_TYPE: "SALES INVOICE",
        cusT_TYPE: "CUSTOMER",
        sno: 0,
        pstatus: "",
        salestype: "BILLING",
        chequeno: "-",
        chqdate: billDate ? billNoDate : date.toISOString(),
        chqamt: 0,
        chqstatus: false,
        accno: "-",
        chqcancell: "NO",
        description: "-",
        cloud_upload: false,
      },
    ];
    try {
      const response = await axios.post(
        `${CREATE_jwel}/api/ERP/InsertTransEntryDataCust`,
        requestBody,
        {
          headers: {
            "Content-Type": "application/json",
            tenantName: tenantName,
          },
        }
      );
      let data = response?.data;
      if (response?.status === 200) {
        // invNoAPI();
        // handleReset();
        // setCashValue("CASH");
        // setCardAmt(0);
        // setUpiAmt(0);
        // setOnlineAmt(0);
        // setCreditAmt(0);
      }
    } catch (error) {
      console.error("Error posting data:", error);
    }
  };

  const paymentModeAPI = async (inv) => {
    let requestBody = [];

    const commonFields = {
      entrydate: billDate
        ? dayjs(billDate).format("YYYY-MM-DD")
        : dayjs().format("YYYY-MM-DD"),
      entryno: invNo ? invNo : inv,
      vno: String(invNo ? invNo : inv),
      vdate: billDate
        ? dayjs(billDate).format("YYYY-MM-DD")
        : dayjs().format("YYYY-MM-DD"),
      scode: 4,
      description: "-",
      salestype: "BILLING",
      hid: 0,
      sno: 0,
      cloud_upload: true,
    };

    if (cashValue === "CASH") {
      requestBody = [
        {
          ...commonFields,
          ledgername: "CASH SALES",
          groupname: "CUSTOMER",
          subgroup: "-",
          maingroup: "",
          particulars: `INVNO:${invNo ? invNo : inv}@CASH-SALE`,
          jamaamount: totalNetAmt,
          namaamount: 0,
          tranS_TYPE: "CASH SALES",
          stype: "CASH SALES",
          paymode: "-",
        },
        {
          ...commonFields,
          ledgername: "CASH BOOK",
          groupname: "CASH BOOK",
          subgroup: "-",
          maingroup: "CASH BOOK",
          particulars: `INVNO:${invNo ? invNo : inv}@CASH-SALE`,
          jamaamount: totalNetAmt,
          namaamount: 0,
          tranS_TYPE: "CASH SALES",
          stype: "CASH BOOK",
          paymode: "-",
        },
      ];
    } else if (
      (cashValue === "CARD" || cashValue === "UPI" || cashValue === "ONLINE") &&
      totalAmt === 0
    ) {
      requestBody = [
        {
          ...commonFields,
          ledgername: "ONLINE SALES",
          groupname: "CUSTOMER",
          subgroup: "-",
          maingroup: "",
          particulars: `INVNO:${invNo ? invNo : inv}@ONLINE-SALE`,
          jamaamount: totalNetAmt,
          namaamount: 0,
          tranS_TYPE: "ONLINE SALES",
          stype: "ONLINE SALES",
          paymode: "-",
        },
        {
          ...commonFields,
          ledgername:
            cashValue === "CARD"
              ? cardAcc
              : cashValue === "UPI"
              ? upiAcc
              : onlineAcc,
          groupname: "CUSTOMER",
          subgroup: "-",
          maingroup: "",
          particulars: `INVNO:${invNo ? invNo : inv}@${
            cashValue === "CARD"
              ? "CARD-SALE"
              : cashValue === "UPI"
              ? "UPI-SALE"
              : "ONLINE-SALE"
          }`,
          jamaamount: 0,
          namaamount:
            cashValue === "CARD"
              ? Number(cardAmt)
              : cashValue === "UPI"
              ? Number(upiAmt)
              : Number(onlineAmt),
          tranS_TYPE: "ONLINE SALES",
          stype: "BANK TRANS",
          paymode: cashValue,
        },
      ];
    } else if (
      (cashValue === "CARD" || cashValue === "UPI" || cashValue === "ONLINE") &&
      totalAmt > 0
    ) {
      requestBody = [
        {
          ...commonFields,
          ledgername: "ONLINE SALES",
          groupname: "CUSTOMER",
          subgroup: "-",
          maingroup: "",
          particulars: `INVNO:${invNo ? invNo : inv}@ONLINE-SALE`,
          jamaamount: totalNetAmt,
          namaamount: 0,
          tranS_TYPE: "ONLINE SALES",
          stype: "ONLINE SALES",
          paymode: "-",
        },
        {
          ...commonFields,
          ledgername:
            cashValue === "CARD"
              ? cardAcc
              : cashValue === "UPI"
              ? upiAcc
              : onlineAcc,
          groupname: "CUSTOMER",
          subgroup: "-",
          maingroup: "",
          particulars: `INVNO:${invNo ? invNo : inv}@${
            cashValue === "CARD"
              ? "CARD-SALE"
              : cashValue === "UPI"
              ? "UPI-SALE"
              : "ONLINE-SALE"
          }`,
          jamaamount: 0,
          namaamount:
            cashValue === "CARD"
              ? Number(cardAmt)
              : cashValue === "UPI"
              ? Number(upiAmt)
              : Number(onlineAmt),
          tranS_TYPE: "CASH SALES",
          stype: "BANK TRANS",
          paymode: cashValue,
        },
        {
          ...commonFields,
          ledgername: "CASH BOOK",
          groupname: "CASH BOOK",
          subgroup: "-",
          maingroup: "CASH BOOK",
          particulars: `INVNO:${invNo ? invNo : inv}@CASH-SALE`,
          jamaamount: totalNetAmt - cardAmt - upiAmt - onlineAmt,
          namaamount: 0,
          tranS_TYPE: "CASH SALES",
          stype: "CASH BOOK",
          paymode: "-",
        },
      ];
    } else if (cashValue === "CREDIT" && creditAmt > 0 && cashAmt > 0) {
      requestBody = [
        {
          ...commonFields,
          ledgername: "CASH SALES",
          groupname: "CUSTOMER",
          subgroup: "-",
          maingroup: "",
          particulars: `INVNO:${invNo ? invNo : inv}@CASH-SALE`,
          jamaamount: Number(totalNetAmt),
          namaamount: 0,
          tranS_TYPE: "   SALES",
          stype: "CASH SALES",
          paymode: "-",
        },
        {
          ...commonFields,
          ledgername: "CASH BOOK",
          groupname: "CASH BOOK",
          subgroup: "-",
          maingroup: "CASH BOOK",
          particulars: `INVNO:${invNo ? invNo : inv}@CASH-SALE`,
          jamaamount: Number(cashAmt),
          namaamount: 0,
          tranS_TYPE: "CASH SALES",
          stype: "CASH BOOK",
          paymode: "-",
        },
        {
          ...commonFields,
          ledgername: userDetails?.Custname,
          groupname: "CUSTOMER",
          subgroup: "-",
          maingroup: "CASH BOOK",
          particulars: `INVNO:${invNo ? invNo : inv}@CASH-SALE`,
          jamaamount: 0,
          namaamount: Number(creditAmt),
          tranS_TYPE: "CASH SALES",
          stype: "CUSTOMER DUE",
          paymode: "-",
        },
      ];
    } else if (cashValue === "CREDIT" && creditAmt > 0) {
      requestBody = [
        {
          ...commonFields,
          ledgername: "CASH SALES",
          groupname: "CUSTOMER",
          subgroup: "-",
          maingroup: "",
          particulars: `INVNO:${invNo ? invNo : inv}@CASH-SALE`,
          jamaamount: Number(totalNetAmt),
          namaamount: 0,
          tranS_TYPE: "   SALES",
          stype: "CASH SALES",
          paymode: "-",
        },
        {
          ...commonFields,
          ledgername: userDetails?.Custname,
          groupname: "CUSTOMER",
          subgroup: "-",
          maingroup: "CASH BOOK",
          particulars: `INVNO:${invNo ? invNo : inv}@CASH-SALE`,
          jamaamount: 0,
          namaamount: Number(creditAmt),
          tranS_TYPE: "CASH SALES",
          stype: "CUSTOMER DUE",
          paymode: "-",
        },
      ];
    }

    try {
      const response = await axios.post(
        `${CREATE_jwel}/api/ERP/InsertSingleEntryData`,
        requestBody,
        {
          headers: {
            "Content-Type": "application/json",
            tenantName: tenantName,
          },
        }
      );
      if (response?.status === 200) {
        // invoiceCountAPI();
        // handleRest();
        // setCashValue("CASH");
        // setCardAmt(0);
        // setUpiAmt(0);
        // setOnlineAmt(0);
        // setCreditCashValue("CREDIT");
        // setSwitchCredit("Cash");
      }
    } catch (error) {
      console.error("Error posting data:", error);
    }
  };

  const onlinePayModeAPI = async (inv) => {
    const requestBody = [
      {
        billno: invNo ? Number(invNo) : Number(inv),
        billdate: billDate ? billNoDate : date.toISOString(),
        bal: Number(totalNetAmt),
        sno: 1,
        paymode: cashValue,
        accno:
          cashValue === "CARD"
            ? cardAcc
            : cashValue === "UPI"
            ? upiAcc
            : onlineAcc,
        narr: "-",
        amt:
          cashValue === "CARD"
            ? Number(cardAmt)
            : cashValue === "UPI"
            ? Number(upiAmt)
            : Number(onlineAmt),
        cntrname: "",
        stype: "SALES",
        ptype: cashValue,
        cloud_upload: true,
      },
    ];
    try {
      const response = await axios.post(
        `${CREATE_jwel}/api/ERP/InsertORGCardDet`,
        requestBody,
        {
          headers: {
            "Content-Type": "application/json",
            tenantName: tenantName,
          },
        }
      );
      let data = response?.data;
      if (response?.status === 200) {
        // invoiceCountAPI();
        // handleRest();
        // setCashValue("CASH");
        // setCardAmt(0);
        // setUpiAmt(0);
        // setOnlineAmt(0);
        // setCreditCashValue("CREDIT");
        // setSwitchCredit("Cash");
      }
    } catch (error) {
      console.error("Error posting data:", error);
    }
  };

  const createStockAddAPI = async () => {
    const requestBody = updatedData.map((item, index) => {
      return {
        code: item?.DesignCode,
        qty: Number(item?.stock),
      };
    });
    try {
      const response = await axios.post(
        `${CREATE_jwel}/api/ERP/StockUpdate?action=ADD`,
        requestBody,
        {
          headers: {
            "Content-Type": "application/json",
            tenantName: tenantName,
          },
        }
      );
      let data = response?.data;
    } catch (error) {
      console.error("Error posting data:", error);
    }
  };

  const createStockUpdateAPI = async () => {
    const requestBody = barCodeData.map((item, index) => {
      return {
        code: item?.DesignCode,
        qty: Number(item?.stock),
      };
    });
    try {
      const response = await axios.post(
        `${CREATE_jwel}/api/ERP/StockUpdate?action=ABC`,
        requestBody,
        {
          headers: {
            "Content-Type": "application/json",
            tenantName: tenantName,
          },
        }
      );
      let data = response?.data;
    } catch (error) {
      console.error("Error posting data:", error);
    }
  };

  const createCustomerDetailsAPI = async (value) => {
    const requestBody = [
      {
        street: "-",
        custname: value?.name || "-",
        add1: value?.address1 || "-",
        add2: value?.address2 || "-",
        add3: value?.address3 || "-",
        area: value?.city || "-",
        phoneno: value?.phone || "-",
        mobileno: value?.mobile1 || "-",
        cardno: "",
        mstatus: "",
        occupation: "",
        education: "",
        college: "",
        discount: 0,
        dob: value?.dob || "",
        annversary: value?.anniversary || "",
        state: value?.state || "-",
        gender: "",
        district: "",
        website: "",
        category: "",
        fax: "-",
        add4: value?.address4 || "-",
        tinno: value?.gstin ?? "-",
        points: 0,
        statecode: value?.stateCode || "",
        station: value?.locationType || "",
        cloud_upload: false,
      },
    ];

    try {
      const response = await axios.post(
        `${CREATE_jwel}/api/ERP/InsertCustomer`,
        requestBody,
        {
          headers: {
            "Content-Type": "application/json",
            tenantName: tenantName,
          },
        }
      );
      let data = response?.data;
      userDetailsAPI(value?.mobile1);
      setFormValues({});
      setOpen(false);
    } catch (error) {
      console.error("Error posting data:", error);
    }
  };

  const userAPI = async () => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetDataFromGivenTableName?tableName=FIRM_CONFIGURE`,
        {
          headers: {
            tenantName: tenantName,
          },
        }
      );

      const data = response.data;

      if (Array.isArray(data) && data.length > 0) {
        const imageUrls = data[0]?.EPASS1.split(",");

        // setImagesData(imageUrls);
        setUserName(data[0]?.FIRMNAME);
        setUserArea(data[0]?.CITY);
        setSingleImage(data[0]?.EPASS2);
        setGstNo(data[0]?.TINNO);
        setUserPhone(data[0]?.MOBILE);
        setConditions(data[0]?.INSTTITLE);
        setIns(data[0]?.INST1);
        setIns1(data[0]?.INST2);
        setIns2(data[0]?.INST3);
        setIns3(data[0]?.INST4);
        setIns4(data[0]?.INST5);
        setIns5(data[0]?.INST6);
        setIns6(data[0]?.INST7);
        setAddress(data[0]?.ADD1);
        setAddress1(data[0]?.ADD2);
        setCity(data[0]?.CITY);
      }
    } catch (error) {
      console.error("Error fetching estimation count:", error);
    }
  };

  const modifyOnlineAPI = async () => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetDataFromGivenTableNameWithWhere?tableName=ORG_CARDDET&where=BILLNO=${modifyCode}`,
        {
          headers: {
            tenantName: tenantName,
          },
        }
      );

      const data = response.data;

      if (Array.isArray(data) && data.length > 0) {
        setModifyCode();
        if (data[0]?.PTYPE === "CARD") {
          setCashValue("CARD");
          setCardAmt(data[0]?.AMT);
        } else if (data[0]?.PTYPE === "UPI") {
          setCashValue("UPI");
          setUpiAmt(data[0]?.AMT);
        } else if (data[0]?.PTYPE === "ONLINE") {
          setCashValue("ONLINE");
          setOnlineAmt(data[0]?.AMT);
        } else {
          setCashValue("CASH");
        }
      }
    } catch (error) {
      console.error("Error fetching estimation count:", error);
    }
  };

  const modifyOpeningLedgerAPI = async () => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetDataFromGivenTableNameWithWhere?tableName=TRANS_ENTRY_DATA_CUST&where=ENTRYNO=${modifyCode}`,
        {
          headers: {
            tenantName: tenantName,
          },
        }
      );

      const data = response.data;

      if (Array.isArray(data) && data.length > 0) {
        if (data[0]?.NAMA > 0) {
          setCashValue("CREDIT");
          setCreditAmt(data[0]?.NAMA);
        }
        setCustomerName(data[0]?.PARTYNAME ?? "");
        setCustomerArea(data[0]?.AREA ?? "");
        setCustomerMobile(data[0]?.AGENTNAME ?? "");
        // userGetDetailsAPI(data[0]?.AGENTNAME);
      }
    } catch (error) {
      console.error("Error fetching estimation count:", error);
    }
  };

  const modifyDetAPI = async () => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetDataFromGivenTableNameWithWhere?tableName=BILL_ITEMS_DET&where=BILLNO=${modifyCode}`,
        {
          headers: {
            "Content-Type": "application/json",
            tenantName: tenantName,
          },
        }
      );
      let data = response?.data;
      let offerARate = 0;
      let offerBRate = 0;

      for (const item of data) {
        if (item.STATION === "A") {
          offerARate = item.CESSPER;
        } else if (item.STATION === "B") {
          offerBRate = item.CESSPER;
        }
      }

      setOfferARate(offerARate);
      setOfferBRate(offerBRate);
      const modifiedData = data.map((item, index) => {
        return {
          ACITY: "-",
          AGENTNAME: "-",
          Area: item?.AREA,
          BOXES: item?.BOXES,
          BRANCHNAME: "-",
          CASERATECP: null,
          CASERATEDP: null,
          CASERATERP: null,
          CGSTAMT: item?.CGSTAMT,
          CGSTRATE: item?.CGSTRATE,
          COLOUR: item?.COLOUR,
          CPrice: item?.rate,
          CTOKEN: 0,
          Code: item?.code,
          CompName: item?.CompName,
          DPrice: item?.DPrice,
          DesignCode: item?.ITEMCODE,
          Disamt: item?.ITEM_DIS,
          Disper: item?.DISPER,
          ECODE: item?.ECODE,
          ENTRYDATE: "-",
          ENTRYNO: 0,
          EQTY: 0,
          EXPDATE: null,
          FITTING: item?.FITTING,
          FLOOR: item?.FLOOR,
          FYEAR: "-",
          GST: item?.GST,
          GSTAMT: item?.GSTAMT,
          GrosDPrice: item?.ITEM_ACTRATE,
          GroupName: item?.GroupName,
          HID: item?.HID,
          HSNCODE: item?.HSNCODE,
          ICODETYPE: "-",
          IGSTAMT: item?.IGSTAMT,
          IGSTRATE: item?.IGSTRATE,
          InvNO: item?.INVNO,
          Invdate: item?.INVDATE,
          ItemCode: "0",
          LASTBILLDATE: "-",
          LENGTH: null,
          LOOSEPCS: null,
          LQTY: null,
          OFFER_DIS: 0,
          OQTY2: Number(item?.PCSPRICE),
          OQTY3: Number(item?.CASEPRICE),
          OQTY4: null,
          PACKPCS: null,
          PNTMODEL: "-",
          PQTY: 0,
          PTYPE: item?.PTYPE,
          Partyname: item?.PARTYNAME,
          ProdName: item?.itemname,
          Prodsize: item?.PRODSIZE,
          Qty: item?.qty,
          RESELLERPRICE: null,
          RQTY: null,
          SEMIWSALERPRICE: null,
          SET_ITEMS: false,
          SGSTAMT: item?.SGSTAMT,
          SGSTRATE: item?.SGSTRATE,
          SLEVES: item?.SLEVES,
          SMODEL: item?.STATION,
          SMCODE: String(item?.SMCODE) ?? "",
          SNO: 0,
          TOKEN: item?.TOKEN,
          USTATUS: null,
          WPER: 0,
          WPRICE: 0,
          stock: item?.qty,
          cloud_upload: false,
          mesure: null,
          offer: item?.ITEM_ACTRATE,
          taans: false,
        };
      });
      if (response?.status === 200) {
        setModifyOpen(false);
        setModifyCode();
        setInvNo(data[0]?.billno);
        setBillDate(data[0]?.billdate);
        handlePdfDownload();
        setUpdatedData(modifiedData);
        for (const item of modifiedData) {
          if (item.DesignCode) {
            await qtyAPI(item.DesignCode); // if qtyAPI is async
          }
        }
        // setBarCodeData((prevData) => {
        //   let updatedData = [...prevData];

        //   // 🔥 Use modifiedData instead of data
        //   const newItems = modifiedData.map((item) => {
        //     const gstItem = gstData.find((gst) => gst.PType === item.PTYPE);

        //     let appliedGST = 0;
        //     if (gstItem?.ALLOWGSTVALUE === true) {
        //       const offerAmount = Number(item.offer) || 0;
        //       if (offerAmount <= gstItem.BELLOWVALUE) {
        //         appliedGST = gstItem.BELLOWPER;
        //       } else if (offerAmount >= gstItem.ABOVEVALUE) {
        //         appliedGST = gstItem.ABOVEPER;
        //       }
        //     } else {
        //       appliedGST = item?.GST;
        //     }

        //     return {
        //       ...item,
        //       GSTApplied: appliedGST,
        //     };
        //   });

        //   newItems.forEach((newItem) => {
        //     const index = updatedData.findIndex(
        //       (existing) => existing.DesignCode === newItem.DesignCode
        //     );

        //     if (index !== -1) {
        //       const currentStock = updatedData[index].stock || 0;
        //       const maxQty = updatedData[index].Qty || 0;

        //       if (currentStock < maxQty) {
        //         updatedData[index] = {
        //           ...updatedData[index],
        //           stock: currentStock + 1,
        //         };
        //       } else {
        //         message.warning("Reached Maximum Qty, Cannot Add More");
        //       }
        //     } else {
        //       updatedData.push(newItem);
        //     }
        //   });

        //   const totalBasic = updatedData.reduce((acc, item) => {
        //     const offer = Number(item.offer) || 0;
        //     const qty = Number(item.stock) || 0;
        //     const gst = Number(item.GSTApplied) || 0;
        //     const netAmt = qty * offer;
        //     return acc + netAmt * (100 / (100 + gst));
        //   }, 0);
        //   setTotalBasicAmount(totalBasic);

        //   const totalGst = updatedData.reduce((acc, item) => {
        //     const offer = Number(item.offer) || 0;
        //     const qty = Number(item.stock) || 0;
        //     const gst = Number(item.GSTApplied) || 0;
        //     const netAmt = qty * offer;
        //     const basic = netAmt * (100 / (100 + gst));
        //     return acc + basic * (gst / 100);
        //   }, 0);
        //   setTotalGstAmt(totalGst);

        //   const totalCGST = updatedData.reduce((acc, item) => {
        //     const offer = Number(item.offer) || 0;
        //     const qty = Number(item.stock) || 0;
        //     const gst = Number(item?.GSTApplied) || 0;
        //     const netAmt = qty * offer;
        //     const value = netAmt * (100 / (100 + gst));
        //     return acc + (value * (gst / 100)) / 2;
        //   }, 0);
        //   setTotalCGSTAmt(totalCGST);

        //   const totalSGST = updatedData.reduce((acc, item) => {
        //     const offer = Number(item.offer) || 0;
        //     const qty = Number(item.stock) || 0;
        //     const gst = Number(item?.GSTApplied) || 0;
        //     const netAmt = qty * offer;
        //     const value = netAmt * (100 / (100 + gst));
        //     return acc + (value * (gst / 100)) / 2;
        //   }, 0);
        //   setTotalSGSTAmt(totalSGST);

        //   return updatedData;
        // });
        setBarCodeData((prevData) => {
          // const existingTag = prevData.some(
          //   (item) => item.DesignCode === scanResult
          // );
          // if (existingTag) {
          //   message.error("Already Existed This Design Code");
          //   return prevData;
          // }

          const updatedData = [
            ...prevData,
            ...modifiedData.map((item) => {
              const gstItem = gstData.find((gst) => gst.PType === item.PTYPE);

              let appliedGST = 0;

              if (gstItem?.ALLOWGSTVALUE === true) {
                const offerAmount = item.offer ?? 0;

                if (offerAmount <= gstItem.BELLOWVALUE) {
                  appliedGST = gstItem.BELLOWPER;
                } else if (offerAmount >= gstItem.ABOVEVALUE) {
                  appliedGST = gstItem.ABOVEPER;
                }
              } else {
                appliedGST = item?.GST;
              }

              return {
                ...item,
                GSTApplied: appliedGST,
              };
            }),
          ];

          const totalBasic = updatedData.reduce((acc, item) => {
            const offer = Number(item.offer) || 0;
            const qty = Number(item.stock) || 0;
            const gst = Number(item.GSTApplied) || 0;
            const netAmt = qty * offer;
            return acc + netAmt * (100 / (100 + gst));
          }, 0);
          setTotalBasicAmount(totalBasic);

          const totalGst = updatedData.reduce((acc, item) => {
            const offer = Number(item.offer) || 0;
            const qty = Number(item.stock) || 0;
            const gst = Number(item.GSTApplied) || 0;
            const netAmt = qty * offer;
            const basic = netAmt * (100 / (100 + gst));
            return acc + basic * (gst / 100);
          }, 0);
          setTotalGstAmt(totalGst);

          const totalCGST = updatedData.reduce((acc, item) => {
            const offer = Number(item.offer) || 0;
            const qty = Number(item.stock) || 0;
            const gst = Number(item?.GSTApplied) || 0;
            const netAmt = qty * offer;
            const value = netAmt * (100 / (100 + gst));
            return acc + (value * (gst / 100)) / 2;
          }, 0);
          setTotalCGSTAmt(totalCGST);

          const totalSGST = updatedData.reduce((acc, item) => {
            const offer = Number(item.offer) || 0;
            const qty = Number(item.stock) || 0;
            const gst = Number(item?.GSTApplied) || 0;
            const netAmt = qty * offer;
            const value = netAmt * (100 / (100 + gst));
            return acc + (value * (gst / 100)) / 2;
          }, 0);
          setTotalSGSTAmt(totalSGST);
          const totalDis = updatedData.reduce((acc, item) => {
            const dis = Number(item.Disper) || 0;
            return acc + dis;
          }, 0);
          setTotalDiscount(totalDis);

          const gstGroupedMap = new Map();

          updatedData.forEach((item) => {
            const key = item.GSTApplied;
            const netAmt = item.stock * item.offer;
            const basicAmt = netAmt * (100 / (100 + key));
            const cgstRate = key / 2;
            const cgstAmt = (netAmt * (key / 100)) / 2;
            const sgstAmt = cgstAmt;

            if (!gstGroupedMap.has(key)) {
              gstGroupedMap.set(key, {
                GST: key,
                CGST_RATE: cgstRate,
                Basic_amt: 0,
                CGST_AMT: 0,
                SGST: cgstRate,
                SGST_AMT: 0,
                NET_AMT: 0,
              });
            }

            const existing = gstGroupedMap.get(key);
            existing.Basic_amt += basicAmt;
            existing.CGST_AMT += cgstAmt;
            existing.SGST_AMT += sgstAmt;
            existing.NET_AMT += netAmt;
          });

          const gstAmtData = Array.from(gstGroupedMap.values());
          setTotalGstData(gstAmtData);

          return updatedData;
        });
      }
    } catch (error) {
      console.error("Error posting data:", error);
    }
  };

  const modifyMastAPI = async (no) => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetDataFromGivenTableNameWithWhere?tableName=CREDIT_BILLMAST&where=BILLNO=${modifyCode}`,
        {
          headers: {
            "Content-Type": "application/json",
            tenantName: tenantName,
          },
        }
      );
      let data = response?.data;

      if (response?.status === 200) {
        setCustomerMobile(data[0]?.PhoneNo);
        setCustomerName(data[0]?.CustName);
        setCustomerArea(data[0]?.Street);
        userGetDetailsAPI(data[0]?.PhoneNo);
      }
    } catch (error) {
      console.error("Error posting data:", error);
    }
  };

  const deleteBarcodeMastAPI = async () => {
    try {
      const response = await axios.post(
        `${CREATE_jwel}/api/ERP/DeleteDataFromGivenTableNameWithWhere?tableName=CREDIT_BILLMAST&where=BILLNO=${invNo}`,
        {},
        {
          headers: {
            tenantName: tenantName,
          },
        }
      );
    } catch (error) {
      console.error(
        "Error posting data:",
        error.response?.data || error.message
      );
    }
  };

  const deleteBarcodeDetAPI = async () => {
    try {
      const response = await axios.post(
        `${CREATE_jwel}/api/ERP/DeleteDataFromGivenTableNameWithWhere?tableName=BILL_ITEMS_DET&where=BILLNO=${invNo}`,
        {},
        {
          headers: {
            tenantName: tenantName,
          },
        }
      );
    } catch (error) {
      console.error(
        "Error posting data:",
        error.response?.data || error.message
      );
    }
  };

  const deleteBarcodeDataAPI = async () => {
    try {
      const response = await axios.post(
        `${CREATE_jwel}/api/ERP/DeleteDataFromGivenTableNameWithWhere?tableName=CREDIT_BILLDATA&where=BILLNO=${invNo}`,
        {},
        {
          headers: {
            tenantName: tenantName,
          },
        }
      );
    } catch (error) {
      console.error(
        "Error posting data:",
        error.response?.data || error.message
      );
    }
  };

  const deleteBarcodePayModeAPI = async () => {
    try {
      const response = await axios.post(
        `${CREATE_jwel}/api/ERP/DeleteDataFromGivenTableNameWithWhere?tableName=SINGLE_ENTRY_DATA&where=ENTRYNO=${invNo}`,
        {},
        {
          headers: {
            tenantName: tenantName,
          },
        }
      );
    } catch (error) {
      console.error(
        "Error posting data:",
        error.response?.data || error.message
      );
    }
  };

  const deleteBarcodeOnlinePayAPI = async () => {
    try {
      const response = await axios.post(
        `${CREATE_jwel}/api/ERP/DeleteDataFromGivenTableNameWithWhere?tableName=ORG_CARDDET&where=BILLNO=${invNo}`,
        {},
        {
          headers: {
            tenantName: tenantName,
          },
        }
      );
    } catch (error) {
      console.error(
        "Error posting data:",
        error.response?.data || error.message
      );
    }
  };

  const deleteBarcodeLedgerAPI = async () => {
    try {
      const response = await axios.post(
        `${CREATE_jwel}/api/ERP/DeleteDataFromGivenTableNameWithWhere?tableName=TRANS_ENTRY_DATA_CUST&where=ENTRYNO=${invNo}`,
        {},
        {
          headers: {
            tenantName: tenantName,
          },
        }
      );
    } catch (error) {
      console.error(
        "Error posting data:",
        error.response?.data || error.message
      );
    }
  };

  const deleteCustomerDetailsAPI = async (mobile) => {
    try {
      const response = await axios.post(
        `${CREATE_jwel}/api/ERP/DeleteDataFromGivenTableNameWithWhere?tableName=CUSTOMER&where=MOBILENO='${mobile}'`,
        {},
        {
          headers: {
            tenantName: tenantName,
          },
        }
      );
    } catch (error) {
      console.error(
        "Error posting data:",
        error.response?.data || error.message
      );
    }
  };

  const sendWhatsAppAPI = async () => {
    const payload = {
      inputJsons: [
        {
          id: "123",
          receiver: "919440353589",
          sender: "917995444031",
          key: "3MjswWu5Hk28BwFePsEdHxLWWY4KhqIRYYesuXmiv0AHI9PRatFW7O5s",
          campaignId: "971",
          templeteName: "salebill_loyalty_pdf",
          fileType: "DOCUMENT",
          fileName: "VEnu3.pdf",
          fileBase: base64,
          clientName: "VENUGOPAL_WHATSAPP",
          params: "VENU,10,100,111,VENU JEWELLERY",
        },
      ],
    };
    try {
      const response = await axios.post(
        `${CREATE_jwel}/api/WhatsApp/SendMessage`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            tenantName: tenantName,
          },
        }
      );
      let data = response?.data;
    } catch (error) {
      console.error("Error posting data:", error);
    }
  };

  // const handleQtyChange = (index, newQty) => {
  //   setBarCodeData((prevData) => {
  //     return prevData.map((item, idx) => {
  //       if (idx === index) {
  //         const validQty = Math.max(1, Math.min(newQty, item.Qty)); // Between 1 and stock
  //         return { ...item, stock: validQty };
  //       }
  //       return item;
  //     });
  //   });
  // };

  const toNumber = (val) => Number(val) || 0;

  const handleQtyChange = (index, newQty) => {
    setBarCodeData((prevData) => {
      const currentItem = prevData[index];
      if (!currentItem) return prevData;

      const designCode = currentItem.DesignCode;

      // 🔹 Max allowed Qty for this DesignCode
      const maxQty =
        qtyData?.find((q) => q.DesignCode === designCode)?.Qty ?? 0;

      // 🔹 Total existing stock for this DesignCode (excluding current row)
      const totalExistingStock = prevData
        .filter((item, idx) => item.DesignCode === designCode && idx !== index)
        .reduce((sum, item) => sum + Number(item.stock || 0), 0);

      // 🔹 Row-level limit
      const rowMaxQty = currentItem.Qty ?? maxQty;

      // 🔹 Clamp qty between 1 and row max
      const validQty = Math.max(1, Math.min(newQty, rowMaxQty));

      // ❌ Prevent exceeding DesignCode total limit
      if (validQty + totalExistingStock > maxQty) {
        message.error(`Qty limit reached for ${designCode}`);
        return prevData;
      }

      return prevData.map((item, idx) =>
        idx === index ? { ...item, stock: validQty } : item
      );
    });
  };

  const handleQtyAChange = (rowIndex, newQty, OQTY3, OQTY2) => {
    const qty = toNumber(newQty);
    const MAX_OFFER_QTY = 3;

    if (qty < 1 || qty > MAX_OFFER_QTY) return;

    const rate = toNumber(offerARate);
    const offerValue = qty === 2 ? toNumber(OQTY2) : toNumber(OQTY3);

    const price = qty === 1 ? rate : offerValue / qty;

    setBarCodeData((prev) =>
      prev.map((item, idx) =>
        idx === rowIndex
          ? {
              ...item,
              stock: qty,
              CPrice: price,
              offer: price,
            }
          : item
      )
    );
  };

  const handleQtyBChange = (rowIndex, newQty, OQTY3, OQTY2, CPrice) => {
    const qty = toNumber(newQty);
    const MAX_QTY = 3;

    if (qty < 1 || qty > MAX_QTY) return;

    const basePrice = toNumber(CPrice);
    const disPer =
      qty === 1
        ? toNumber(offerBRate)
        : qty === 2
        ? toNumber(OQTY2)
        : toNumber(OQTY3);

    const disAmt = (basePrice * disPer) / 100;
    const actRate = basePrice - disAmt;

    setBarCodeData((prev) =>
      prev.map((item, idx) =>
        idx === rowIndex
          ? {
              ...item,
              stock: qty,
              Disper: disPer,
              Disamt: disAmt,
              CPrice: basePrice,
              offer: actRate,
            }
          : item
      )
    );
  };

  useEffect(() => {
    const totalNet = barCodeData.reduce((acc, item) => {
      const offer = Number(item.offer) || 0;
      const qty = Number(item.stock) || 0;
      return acc + qty * offer;
    }, 0);
    setTotalNetAmt(totalNet);
    setCashAmt(totalNet);
    const totalAmount = barCodeData.reduce((acc, item) => {
      const price = Number(item.CPrice) || 0;
      const qty = Number(item.stock) || 0;
      return acc + qty * price;
    }, 0);
    setTotalAmount(totalAmount);
    const totalQTY = barCodeData.reduce((acc, item) => {
      const qty = Number(item.stock) || 0;
      return acc + qty;
    }, 0);
    setTotalQty(totalQTY);
    const totalDisAmt = barCodeData.reduce((acc, item) => {
      const dis = Number(item.Disamt) || 0;
      const qty = Number(item.stock) || 0;
      return acc + qty * dis;
    }, 0);
    setTotalDisAmt(totalDisAmt);
  }, [barCodeData]);

  const handleDelete = (indexToDelete) => {
    tagNoRef.current?.focus();
    setBarCodeData((prevData) => {
      const updatedData = [...prevData];
      updatedData.splice(indexToDelete, 1);
      return updatedData;
    });
  };

  const html5QrCodeRef = useRef(null);
  const scannedRef = useRef(false);

  const SCAN_COOLDOWN_MS = 1000;

  const startScanner = async () => {
    try {
      const config = {
        fps: 10,
        qrbox: { width: 250, height: 250 },
        rememberLastUsedCamera: true,
      };

      const html5QrCode = new Html5Qrcode("qr-reader");
      html5QrCodeRef.current = html5QrCode;

      await html5QrCode.start(
        { facingMode: "environment" },
        config,
        async (decodedText) => {
          if (scannedRef.current) return;

          scannedRef.current = true;

          try {
            await mainAPI(decodedText);
            await homeBillData(decodedText);
          } catch (err) {
            console.error("Scan handling error:", err);
          }

          setTimeout(() => {
            scannedRef.current = false;
          }, SCAN_COOLDOWN_MS);
        },
        (error) => {
          console.warn("QR Scan Error:", error);
        }
      );
    } catch (error) {
      console.error("Failed to start scanner:", error);
    }
  };

  const stopScanner = async () => {
    tagNoRef.current?.focus();
    if (html5QrCodeRef.current) {
      try {
        await html5QrCodeRef.current.stop();
        await html5QrCodeRef.current.clear();
      } catch (err) {
        console.error("Error stopping scanner:", err);
      } finally {
        html5QrCodeRef.current = null;
        setQrOpen(false);
        scannedRef.current = false;
      }
    } else {
      setQrOpen(false);
      scannedRef.current = false;
    }
  };

  const handleOpenScanner = () => {
    setQrOpen(true);
    setTimeout(() => startScanner(), 300); // give DOM time to mount
    tagNoRef.current?.focus();
  };

  useEffect(() => {
    gstCheckAPI();
    invoiceCountAPI();
    userAPI();
    onlineAccNoAPI();
    commissionAPI();
  }, []);

  const handleOk = () => {
    setCustomerOpen(true);
  };

  const handleCancel = () => {
    setCustomerOpen(false);
    tagNoRef.current?.focus();
  };

  const handleCardOpen = (code) => {
    setCardOpen(true);
    const gst = code.GSTApplied;
    const basicAmt = code.stock * code.offer * (100 / (100 + code.GSTApplied));
    const gstAmt = basicAmt * (code.GSTApplied / 100);
    const cGstRate = code.GSTApplied / 2;
    const cGstAmt = (basicAmt * (code.GSTApplied / 100)) / 2;
    const sGstRate = code.GSTApplied / 2;
    const sGstAmt = (basicAmt * (code.GSTApplied / 100)) / 2;
    const netAmt = code.stock * code.offer;
    setTitleValue(code.DesignCode);
    setGst(gst);
    setGstAmt(gstAmt);
    setCGstRate(cGstRate);
    setCGstAmt(cGstAmt);
    setSGstRate(sGstRate);
    setSGstAmt(sGstAmt);
    setIGstRate(code.GSTApplied);
    setIGstAmt(0);
    setBasicAmt(basicAmt);
    setNetAmt(netAmt);
    setSmCode(code?.SMCODE);
  };

  const handleCardCancel = () => {
    setCardOpen(false);
    tagNoRef.current?.focus();
  };

  const handleModifyOpen = () => {
    setModifyOpen(true);
  };

  const handleModifyCancel = () => {
    setModifyOpen(false);
    tagNoRef.current?.focus();
  };

  const handleCashOpen = () => {
    setCashOpen(true);
  };

  const handleCashCancel = () => {
    setCashOpen(false);
    tagNoRef.current?.focus();
  };
  const handleToggleScan = () => {
    setScanOpen((prev) => !prev);
    tagNoRef.current?.focus();
  };

  const handleRest = () => {
    // window.location.reload();
    tagNoRef.current?.focus();
    invoiceCountAPI();
    commissionAPI();
    gstCheckAPI();
    onlineAccNoAPI();
    setBarCodeData([]);
    setScanResult("");
    setTotalAmount(0);
    setTotalDisAmt(0);
    setTotalNetAmt(0);
    setTotalQty(0);
    setCustomerArea("");
    setCustomerName("");
    setCustomerMobile("");
    setInvNo(0);
    setModifyCode();
    setCashValue("CASH");
    setCashAmt(0);
    setCardAmt(0);
    setUpiAmt(0);
    setOnlineAmt(0);
    setCreditAmt(0);
    setCreditCardAmt(0);
    setCreditUpiAmt(0);
    setCreditOnlineAmt(0);
    setCreditCashAmt(0);
    setCreditCashValue("CREDIT");
    setSwitchCredit("Cash");
    setUpdatedData([]);
    setTotalBasicAmount(0);
    setBillDate();
    setQtyData([]);
    setOfferAData([]);
    setOfferARate(0);
    setOfferBData([]);
    setOfferBRate(0);
    setUserDetails({});
    setPhoneNo();
    setFormValues({
      mobile1: "",
      city: "",
      name: "",
      mobile2: "",
      phone: "",
      address1: "",
      address2: "",
      address3: "",
      address4: "",
      state: "ANDHRA PRADESH",
      stateCode: "37",
      gstin: "",
      panNo: "",
      idProof: "",
      dob: "",
      anniversary: "",
      locationType: "LOCAL",
    });
  };

  const handlePrint = () => {
    const printWindow = window.open("", "", "height=700,width=900");

    printWindow.document.write(`
    <html>
    <head>
      <title>Barcode Print</title>
      <style>
         @page {
          size: auto;
          margin: 3mm;
        }
        body {
          margin: 0;
          font-family: Arial, sans-serif;
          font-size: 10px;
          display: flex;
          justify-content: center;
        }
        .print-container {
          width: 100%;
          max-width: 600px;
          margin: 0 auto;
        }
        .header {
          text-align: center;
          margin-bottom: 5px;
        }
        .header h2 {
          margin: 0;
          font-size: 12px;
          font-weight: bold;
        }
        .sub-header {
          display: flex;
          justify-content: space-between;
          font-size: 9px;
          font-weight: bold;
          margin-bottom: 8px;
          padding-bottom: 4px;
        }
        table {
          width: 100%;
          border-collapse: collapse;
          font-size: 9px;
          margin-top: 5px;
        }
        th, td {
          border: 1px solid black;
          padding: 3px;
          text-align: center;
        }
        th {
          background-color: #e0e0e0;
          font-weight: bold;
        }
        .total {
          font-weight: bold;
          background-color: #ddd;
        }
        .summary {
          display: flex;
          justify-content: space-between;
          margin-top: 10px;
        }
        .summary-box {
          width: 48%;
          border: 1px solid black;
          padding: 5px;
          font-size: 9px;
        }
        .summary-box table {
          width: 100%;
          border: none;
        }
        .summary-box td {
          border: none;
          text-align: left;
          padding: 2px 0;
        }
        .footer {
          margin-top: 10px;
          font-size: 9px;
        }
      </style>
    </head>
    <body>
      <div class="print-container">
  `);

    // Header
    printWindow.document.write(`
    <div class="header">
      <img src="${base64Images}" alt="TLogo" style="width: 200px; height: 200px; margin-bottom: 5px;">
      <h2>${address}</h2>
      <h2>${address1}</h2>
      <h2>${city}</h2>
      <h2>${gstNo}</h2>
      <h2>PHONE NO: ${userPhone}</h2>
    </div>
  `);

    // Invoice header
    printWindow.document.write(`
    <div style="border: 1px solid black; margin-top: 5px; font-size: 9px; padding: 0;">
      <div style="display: flex; justify-content: center; align-items: center; background-color: #162566; height: 30px; border-bottom: 1px solid black;">
        <div style="flex: 1; font-size: 12px; color: white; text-align: center; font-weight: bold; padding: 3px;">
          TAX INVOICE
        </div>
      </div>
     <div style="display: flex;">
    <div style="flex: 1; padding: 5px 8px;">
      <div style="display: flex; font-size: 12px; margin-bottom: 5px;">
        <div style="width: 90px;">Invoice No</div>
        <div style="width: 10px; font-weight: bold;">:</div>
        <div style="font-size: 14px; font-weight: bold; color: red;">#${
          invNo ? invNo : invoiceNo
        }</div>
      </div>
      <div style="display: flex; font-size: 12px; margin-bottom: 5px;">
        <div style="width: 90px;">Customer</div>
        <div style="width: 10px; font-weight: bold;">:</div>
        <div style="font-size: 12px; font-weight: bold;">${
          customerName || "-"
        }</div>
      </div>
      <div style="display: flex; font-size: 12px; margin-bottom: 5px;">
        <div style="width: 90px;">Contact</div>
        <div style="width: 10px; font-weight: bold;">:</div>
        <div style="font-size: 12px; font-weight: bold;">${
          customerMobile || "-"
        }</div>
      </div>
    </div>
    <div style="flex: 1; padding: 5px 8px;">
      <div style="display: flex; font-size: 12px; margin-bottom: 5px;">
        <div style="width: 90px;">Invoice Date</div>
        <div style="width: 10px; font-weight: bold;">:</div>
        <div style="font-size: 12px; font-weight: bold;">${dayjs().format(
          "DD-MMM-YYYY"
        )} / ${dayjs().format("hh:mm A")}</div>
      </div>
      </div>
  </div>
    </div>
  `);

    // Table
    printWindow.document.write(`
    <style>
      table {
        width: 100%;
        border-collapse: collapse;
        border: 1px solid black;
        font-family: Arial, sans-serif;
        font-size: 9px;
      }
      th, td {
        border: 1px solid black;
        padding: 3px;
        text-align: center;
        vertical-align: middle;
      }
      th {
        font-weight: bold;
        background-color: #162566;
        font-size: 12px;
        height: 30px;
        justify-content: center;
        align-items: center;
        color: white;
      }
      td strong {
        font-size: 10px;
      }
      td span {
        font-size: 10px;
      }
      .total td {
        font-weight: bold;
        background-color: #f0f0f0;
      }
      td div.sub-text {
  text-align: left;
  font-size: 8px;
  font-weight: bold;
}
        td div.sub-code {
  font-size: 10px;
  font-weight: bold;
  background-color: #52bd91;
  border: 1px solid #52bd91;
  border-radius: 4px;
  padding: 4px 5px 3px 5px;
  display: inline-block;
  color: white;
}
  td div.sub-hsn {
  display: inline-block;
  font-size: 9px;
  margin-left: 30px;
}
      td div.sub-value {
        text-align: left;
        font-size: 8px;
      }
      tr.sub-row td {
  border-top: none;
  text-align: left;
}
      .sub {
        text-align: left;
        padding: 5px 5px;
      }
        .sub-name {
        text-align: center;
        font-size: 9px;
        border: 1px solid White;
      }
        .sub-qty {
        text-align: center;
        font-size: 9px;
        border: 1px solid White;
      }
      .sub-right {
        text-align: right;
        width: 60px;
      }
        .sub-rights {
        text-align: right;
        width: 30px;
      }
        .sub-amount {
        text-align: right;
        width: 70px;
        background-color: #c5dfe8ff;
      }
        .sub-qtys {
        text-align: center;
        width: 30px;
        background-color: #d3e8f0ff;
      }
         .sub-no {
        text-align: center;
        font-size: 10px;
        width: 40px;
        background-color: #d3e8f0ff;
      }
        .sub-all {
        text-align: center;
        width: 60px;
        font-size: 9px;
        border: 1px solid White;
      }
        .sub-amounts {
        text-align: center;
        width: 70px;
        font-size: 9px;
        border: 1px solid White;
      }
        .sub-sno {
        text-align: center;
        font-size: 10px;
        width: 40px;
        border: 1px solid White;
      }
        sub
    </style>
    <table>
      <thead>
        <tr>
          <th class="sub-sno">SNo</th><th class="sub-name">PARTICULARS</th><th class="sub-qty">QTY</th><th class="sub-all">RATE</th>
          <th class="sub-all">DISC</th><th class="sub-amounts">AMOUNT</th>
        </tr>
      </thead>
      <tbody>
  `);

    barCodeData.forEach((item, index) => {
      const removeUndefinedWrapper = (str) => {
        let prevStr;
        do {
          prevStr = str;
          str = str.replace(/undefined\(\s*(.*?)\s*\)/g, "$1").trim();
        } while (prevStr !== str);
        return str;
      };

      const cleanedActGrams = removeUndefinedWrapper(item.HSNCODE);
      const cleanedCode = removeUndefinedWrapper(item.DesignCode);

      printWindow.document.write(`
      <tr>
      <td class="sub-no" rowspan="${
        cleanedActGrams && cleanedCode ? 2 : 1
      }"><strong>${index + 1}</strong></td>
        
        <td class="sub">${item.ProdName}</td>
        <td class="sub-qtys">${item.stock}</td>
        <td class="sub-right">${item.CPrice.toFixed(2)}</td>
        <td class="sub-right">${item.Disper.toFixed(2)}</td>
        <td class="sub-amount" rowspan="${
          cleanedActGrams && cleanedCode ? 2 : 1
        }"><strong>${Number(item.stock * item.offer).toFixed(2)}</strong></td>
      </tr>
    `);

      if (cleanedActGrams) {
        printWindow.document.write(`
        <tr class="sub-row">
  <td colspan="4">
    <div class="sub-text">
      <div class="sub-code">${cleanedCode}</div>
      <div class="sub-hsn">HSN: ${cleanedActGrams}</div>
    </div>
  </td>
</tr>
      `);
      }
    });

    const totals = totalGstData.reduce(
      (acc, row) => {
        acc.Basic_amt += row.Basic_amt;
        acc.CGST_AMT += row.CGST_AMT;
        acc.SGST_AMT += row.SGST_AMT;
        acc.NET_AMT += row.NET_AMT;
        return acc;
      },
      { Basic_amt: 0, CGST_AMT: 0, SGST_AMT: 0, NET_AMT: 0 }
    );

    // Generate table body rows
    const tableBodyHTML =
      totalGstData
        .map(
          (row) => `
  <tr>
    <td style="border: 1px solid black; text-align: left;">${row.Basic_amt.toFixed(
      2
    )}</td>
    <td style="border: 1px solid black; text-align: right;">${
      row.CGST_RATE
    }%</td>
    <td style="border: 1px solid black; text-align: right;">${row.CGST_AMT.toFixed(
      2
    )}</td>
    <td style="border: 1px solid black; text-align: right;">${row.SGST}%</td>
    <td style="border: 1px solid black; text-align: right;">${row.SGST_AMT.toFixed(
      2
    )}</td>
    <td style="border: 1px solid black; text-align: right;">${row.NET_AMT.toFixed(
      2
    )}</td>
  </tr>
`
        )
        .join("") +
      `
  <tr>
    <td style="border: 1px solid black; text-align: left; font-weight: bold;">${totals.Basic_amt.toFixed(
      2
    )}</td>
    <td style="border: 1px solid black;"></td>
    <td style="border: 1px solid black; text-align: right; font-weight: bold;">${totals.CGST_AMT.toFixed(
      2
    )}</td>
    <td style="border: 1px solid black;"></td>
    <td style="border: 1px solid black; text-align: right; font-weight: bold;">${totals.SGST_AMT.toFixed(
      2
    )}</td>
    <td style="border: 1px solid black; text-align: right; font-weight: bold;">${totals.NET_AMT.toFixed(
      2
    )}</td>
  </tr>
`;

    printWindow.document.write(`
      </tbody>
    </table>

    <div style="font-size: 10px; margin-top: 5px;">
      <div style="border: 1px solid #141414ff; font-size: 12px; font-family: Arial, sans-serif;">
  <div style="padding: 8px;">
    <div style="display: flex; justify-content: space-between; margin-bottom: 4px;">
      <span style="flex: 1;">Total Amount</span>
      <span style="flex: 0 0 10px; text-align: center; font-weight: bold;">:</span>
      <span style="flex: 1; text-align: right;">${totalAmount.toFixed(2)}</span>
    </div>
    <div style="display: flex; justify-content: space-between;">
      <span style="flex: 1;">Discount</span>
      <span style="flex: 0 0 10px; text-align: center; font-weight: bold;">:</span>
      <span style="flex: 1; text-align: right;">${totalDiscount.toFixed(
        2
      )}</span>
    </div>
  </div>

  <div style="background-color: #52bd91; font-weight: bold; display: flex; align-items: center; padding: 8px; border-top: 1px solid #0d0d0eff;">
    <div style="flex: 1; display: flex; align-items: center;">
      <span style="color: red; font-size: 14px; margin-right: 6px;">&#10148;</span>
      <span>Net Amount</span>
    </div>
    <span style="flex: 0 0 10px; text-align: center; font-weight: bold;">:</span>
    <div style="flex: 1; text-align: right; font-size: 16px; color: white;">${totalNetAmt?.toFixed(
      2
    )}</div>
  </div>
</div>


      <div style="display: flex; justify-content: space-between; align-items: center; margin-top: 5px; font-weight: bold;">
        <div style="display: flex; align-items: center;">
          <span style="color: red; font-size: 14px; margin-right: 6px;">&#10148;</span> <span style:"font-size: 14px; font-weight: bold;">Total Qty :</span>
          <span style="border: 1px solid #52bd91; padding: 5px 8px 5px 8px; margin-left: 5px; font-size: 14px; border-radius: 4px; background-color: #52bd91;">${totalQty}</span>
        </div>
        <div>RE-PRINT</div>
      </div>

      <table style="width: 100%; border-collapse: collapse; font-size: 10px; margin-top: 10px; font-family: Arial, sans-serif;">
  <thead style:"height: 50px; background-color: #a9f0d2ff;">
    <tr>
      <th rowspan="2" style="border: 1px solid white; text-align: center; vertical-align: middle; font-size: 8px; height: 10px;">BASIC AMOUNT</th>
      <th colspan="2" style="border: 1px solid white; text-align: center; font-size: 8px; height: 10px;">CENTRAL TAX</th>
      <th colspan="2" style="border: 1px solid white; text-align: center; font-size: 8px; height: 10px;">STATE TAX</th>
      <th rowspan="2" style="border: 1px solid white; text-align: center; vertical-align: middle; font-size: 8px; height: 10px;">NET AMT</th>
    </tr>
    <tr>
      <th style="border: 1px solid white; text-align: center; font-size: 8px; height: 10px;">(%)</th>
      <th style="border: 1px solid white; text-align: center; font-size: 8px; height: 10px;">CGST</th>
      <th style="border: 1px solid white; text-align: center; font-size: 8px; height: 10px;">(%)</th>
      <th style="border: 1px solid white; text-align: center; font-size: 8px; height: 10px;">SGST</th>
    </tr>
  </thead>
  <tbody>
    ${tableBodyHTML}
  </tbody>
</table>

      <div style="margin-top: 10px; font-size: 9px; padding-top: 5px; text-align: center;">
        <span style="font-size: 14px;">Terms & Conditions</span>
        <ul style="text-align: left; margin-top: 5px;">
          <li style="margin-bottom: 5px;">${ins}</li>
          <li style="margin-bottom: 5px;">${ins1}</li>
          <li style="margin-bottom: 5px;">${ins2}</li>
          <li style="margin-bottom: 5px;">${ins3}</li>
          <li style="margin-bottom: 5px;">${ins4}</li>
          <li style="margin-bottom: 5px;">${ins5}</li>
          <li style="margin-bottom: 5px;">${ins6}</li>
        </ul>
      </div>

        <div style="background-color: #add8e6; display: flex; justify-content: center; align-items: center; padding: 8px; border-radius: 10px;">
    <div style=" display: flex; justify-content: center; align-items: center; font-size: 12px; font-family: Times New Roman;">
      Thank You Please Visit Again
    </div>
  </div>
    </div>

  </div> <!-- close .print-container -->
</body>
</html>
  `);

    printWindow.document.close();
    printWindow.print();
  };

  const handlePdfDownload = async () => {
    const element = document.createElement("div");

    const sharedStyles = `
    <style>
      table {
        width: 100%;
        border-collapse: collapse;
        border: 1px solid black;
        font-family: Arial, sans-serif;
        font-size: 9px;
      }
      th, td {
        border: 1px solid black;
        padding: 3px;
        text-align: center;
        vertical-align: middle;
      }
      th {
        font-weight: bold;
        background-color: #162566;
        font-size: 12px;
        height: 30px;
        justify-content: center;
        align-items: center;
        color: white;
      }
      td strong {
        font-size: 10px;
      }
      td span {
        font-size: 10px;
      }
      .total td {
        font-weight: bold;
        background-color: #f0f0f0;
      }
      td div.sub-text {
  text-align: left;
  font-size: 8px;
  font-weight: bold;
}
        td div.sub-code {
  font-size: 10px;
  font-weight: bold;
  background-color: #52bd91;
  border: 1px solid #52bd91;
  border-radius: 4px;
  padding: 4px 5px 3px 5px;
  display: inline-block;
  color: white;
}
  td div.sub-hsn {
  display: inline-block;
  font-size: 9px;
  margin-left: 30px;
}
      td div.sub-value {
        text-align: left;
        font-size: 8px;
      }
      tr.sub-row td {
  border-top: none;
  text-align: left;
}
      .sub {
        text-align: left;
        padding: 5px 5px;
      }
        .sub-name {
        text-align: center;
        font-size: 9px;
        border: 1px solid White;
      }
        .sub-qty {
        text-align: center;
        font-size: 9px;
        border: 1px solid White;
      }
      .sub-right {
        text-align: right;
        width: 60px;
      }
        .sub-rights {
        text-align: right;
        width: 30px;
      }
        .sub-amount {
        text-align: right;
        width: 70px;
        background-color: #c5dfe8ff;
      }
        .sub-qtys {
        text-align: center;
        width: 30px;
        background-color: #d3e8f0ff;
      }
         .sub-no {
        text-align: center;
        font-size: 10px;
        width: 40px;
        background-color: #d3e8f0ff;
      }
        .sub-all {
        text-align: center;
        width: 60px;
        font-size: 9px;
        border: 1px solid White;
      }
        .sub-amounts {
        text-align: center;
        width: 70px;
        font-size: 9px;
        border: 1px solid White;
      }
        .sub-sno {
        text-align: center;
        font-size: 10px;
        width: 40px;
        border: 1px solid White;
      }
        sub
    </style>
  `;
    const totals = totalGstData.reduce(
      (acc, row) => {
        acc.Basic_amt += row.Basic_amt;
        acc.CGST_AMT += row.CGST_AMT;
        acc.SGST_AMT += row.SGST_AMT;
        acc.NET_AMT += row.NET_AMT;
        return acc;
      },
      { Basic_amt: 0, CGST_AMT: 0, SGST_AMT: 0, NET_AMT: 0 }
    );

    const tableBodyHTML =
      totalGstData
        .map(
          (row) => `
  <tr>
    <td style="border: 1px solid black; text-align: left;">${row.Basic_amt.toFixed(
      2
    )}</td>
    <td style="border: 1px solid black; text-align: right;">${
      row.CGST_RATE
    }%</td>
    <td style="border: 1px solid black; text-align: right;">${row.CGST_AMT.toFixed(
      2
    )}</td>
    <td style="border: 1px solid black; text-align: right;">${row.SGST}%</td>
    <td style="border: 1px solid black; text-align: right;">${row.SGST_AMT.toFixed(
      2
    )}</td>
    <td style="border: 1px solid black; text-align: right;">${row.NET_AMT.toFixed(
      2
    )}</td>
  </tr>
`
        )
        .join("") +
      `
  <tr>
    <td style="border: 1px solid black; text-align: left; font-weight: bold;">${totals.Basic_amt.toFixed(
      2
    )}</td>
    <td style="border: 1px solid black;"></td>
    <td style="border: 1px solid black; text-align: right; font-weight: bold;">${totals.CGST_AMT.toFixed(
      2
    )}</td>
    <td style="border: 1px solid black;"></td>
    <td style="border: 1px solid black; text-align: right; font-weight: bold;">${totals.SGST_AMT.toFixed(
      2
    )}</td>
    <td style="border: 1px solid black; text-align: right; font-weight: bold;">${totals.NET_AMT.toFixed(
      2
    )}</td>
  </tr>
`;
    const content = `
    ${sharedStyles}
   <div style="margin: 0; font-family: Arial, sans-serif; font-size: 10px; display: flex; justify-content: center;">
  <div style="width: 90mm; margin: 0 auto; padding-left: 5mm; padding-right: 5mm; box-sizing: border-box;">
      <div style="text-align: center; margin-bottom: 5px;">
        <img src="${singleImage}" alt="TLogo" style="width: 200px; height: 200px; margin-bottom: 5px;">
        <h2 style="margin: 0; font-size: 12px; font-weight: bold;">${address}</h2>
        <h2 style="margin: 0; font-size: 12px; font-weight: bold;">${address1}</h2>
        <h2 style="margin: 0; font-size: 12px; font-weight: bold;">${city}</h2>
        <h2 style="margin: 0; font-size: 12px; font-weight: bold;">${gstNo}</h2>
        <h2 style="margin: 0; font-size: 12px; font-weight: bold;">PHONE NO: ${userPhone}</h2>
      </div>

      <!-- Tax Invoice Header -->
      <div style="border: 1px solid black; margin-top: 5px; font-size: 9px; padding: 0;">
        <div style="display: flex; justify-content: center; align-items: center; background-color: #162566; height: 30px; border-bottom: 1px solid black;">
          <div style="flex: 1; font-size: 12px; color: white; text-align: center; font-weight: bold; padding: 3px;">TAX INVOICE</div>
        </div>
        <div style="display: flex;">
          <div style="flex: 1; padding: 5px 8px;">
            <div style="display: flex; font-size: 12px; margin-bottom: 5px;">
              <div style="width: 90px;">Invoice No</div><div style="width: 10px; font-weight: bold;">:</div>
              <div style="font-size: 14px; font-weight: bold; color: red;">#${
                invNo ? invNo : invoiceNo
              }</div>
            </div>
            <div style="display: flex; font-size: 12px; margin-bottom: 5px;">
              <div style="width: 90px;">Customer</div><div style="width: 10px; font-weight: bold;">:</div>
              <div style="font-size: 12px; font-weight: bold;">${
                customerName || "-"
              }</div>
            </div>
            <div style="display: flex; font-size: 12px; margin-bottom: 5px;">
              <div style="width: 90px;">Contact</div><div style="width: 10px; font-weight: bold;">:</div>
              <div style="font-size: 12px; font-weight: bold;">${
                customerMobile || "-"
              }</div>
            </div>
          </div>
          <div style="flex: 1; padding: 5px 8px;">
            <div style="display: flex; font-size: 12px; margin-bottom: 5px;">
              <div style="width: 90px;">Invoice Date</div><div style="width: 10px; font-weight: bold;">:</div>
              <div style="font-size: 12px; font-weight: bold;">${dayjs().format(
                "DD-MMM-YYYY"
              )} / ${dayjs().format("hh:mm A")}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- Item Table -->
      <table style="width: 100%; border-collapse: collapse; border: 1px solid black; font-family: Arial, sans-serif; font-size: 9px; margin-top: 5px;">
        <thead>
          <tr>
            <th class="sub-sno">SNo</th><th class="sub-name">PARTICULARS</th><th class="sub-qty">QTY</th><th class="sub-all">RATE</th>
          <th class="sub-all">DISC</th><th class="sub-amounts">AMOUNT</th>
          </tr>
        </thead>
        <tbody>
          ${barCodeData
            .map((item, index) => {
              const removeUndefinedWrapper = (str) =>
                str.replace(/undefined\(\s*(.*?)\s*\)/g, "$1").trim();
              const cleanedActGrams = removeUndefinedWrapper(item.HSNCODE);
              const cleanedCode = removeUndefinedWrapper(item.DesignCode);

              const subRow = cleanedActGrams
                ? `
              <tr class="sub-row">
  <td colspan="4">
    <div class="sub-text">
      <div class="sub-code">${cleanedCode}</div>
      <div class="sub-hsn">HSN: ${cleanedActGrams}</div>
    </div>
  </td>
</tr>`
                : "";

              return `
                <tr>
                <td class="sub-no" rowspan="${
                  cleanedActGrams && cleanedCode ? 2 : 1
                }"><strong>${index + 1}</strong></td>
                  <td class="sub">${item.ProdName}</td>
        <td class="sub-qtys">${item.stock}</td>
        <td class="sub-right">${item.CPrice.toFixed(2)}</td>
        <td class="sub-right">${item.Disper.toFixed(2)}</td>
        <td class="sub-amount" rowspan="${
          cleanedActGrams && cleanedCode ? 2 : 1
        }"><strong>${Number(item.stock * item.offer).toFixed(2)}</strong></td>
                </tr>
                ${subRow}
              `;
            })
            .join("")}
        </tbody>
      </table>

      <!-- Summary Section -->
      <div style="font-size: 10px; margin-top: 5px;">
      <div style="border: 1px solid #141414ff; font-size: 12px; font-family: Arial, sans-serif;">
  <div style="padding: 8px;">
    <div style="display: flex; justify-content: space-between; margin-bottom: 4px;">
      <span style="flex: 1;">Total Amount</span>
      <span style="flex: 0 0 10px; text-align: center; font-weight: bold;">:</span>
      <span style="flex: 1; text-align: right;">${totalAmount.toFixed(2)}</span>
    </div>
    <div style="display: flex; justify-content: space-between;">
      <span style="flex: 1;">Discount</span>
      <span style="flex: 0 0 10px; text-align: center; font-weight: bold;">:</span>
      <span style="flex: 1; text-align: right;">${totalDisAmt.toFixed(2)}</span>
    </div>
  </div>

  <div style="background-color: #52bd91; font-weight: bold; display: flex; align-items: center; padding: 8px; border-top: 1px solid #0d0d0eff;">
    <div style="flex: 1; display: flex; align-items: center;">
      <span style="color: red; font-size: 14px; margin-right: 6px;">&#10148;</span>
      <span>Net Amount</span>
    </div>
    <span style="flex: 0 0 10px; text-align: center; font-weight: bold;">:</span>
    <div style="flex: 1; text-align: right; font-size: 16px; color: white;">${totalNetAmt?.toFixed(
      2
    )}</div>
  </div>
</div>


      <div style="display: flex; justify-content: space-between; align-items: center; margin-top: 5px; font-weight: bold;">
        <div style="display: flex; align-items: center;">
          <span style="color: red; font-size: 14px; margin-right: 6px;">&#10148;</span> <span style:"font-size: 14px; font-weight: bold;">Total Qty :</span>
          <span style="border: 1px solid #52bd91; padding: 5px 8px 5px 8px; margin-left: 5px; font-size: 14px; border-radius: 4px; background-color: #52bd91;">${totalQty}</span>
        </div>
        <div>RE-PRINT</div>
      </div>


      <!-- GST Table -->
      <table style="width: 100%; border-collapse: collapse; font-size: 10px; margin-top: 10px;">
        <thead style:"height: 50px; background-color: #a9f0d2ff;">
    <tr>
      <th rowspan="2" style="border: 1px solid white; text-align: center; vertical-align: middle; font-size: 8px; height: 10px;">BASIC AMOUNT</th>
      <th colspan="2" style="border: 1px solid white; text-align: center; font-size: 8px; height: 10px;">CENTRAL TAX</th>
      <th colspan="2" style="border: 1px solid white; text-align: center; font-size: 8px; height: 10px;">STATE TAX</th>
      <th rowspan="2" style="border: 1px solid white; text-align: center; vertical-align: middle; font-size: 8px; height: 10px;">NET AMT</th>
    </tr>
    <tr>
      <th style="border: 1px solid white; text-align: center; font-size: 8px; height: 10px;">(%)</th>
      <th style="border: 1px solid white; text-align: center; font-size: 8px; height: 10px;">CGST</th>
      <th style="border: 1px solid white; text-align: center; font-size: 8px; height: 10px;">(%)</th>
      <th style="border: 1px solid white; text-align: center; font-size: 8px; height: 10px;">SGST</th>
    </tr>
  </thead>
        <tbody>
          ${tableBodyHTML}
        </tbody>
      </table>

      <!-- Terms & Footer -->
      <div style="margin-top: 10px; font-size: 9px; padding-top: 5px; text-align: center;">
        <span style="font-size: 14px;">Terms & Conditions</span>
        <ul style="text-align: left; margin-top: 5px;">
          <li style="margin-bottom: 5px;">${ins}</li>
          <li style="margin-bottom: 5px;">${ins1}</li>
          <li style="margin-bottom: 5px;">${ins2}</li>
          <li style="margin-bottom: 5px;">${ins3}</li>
          <li style="margin-bottom: 5px;">${ins4}</li>
          <li style="margin-bottom: 5px;">${ins5}</li>
          <li style="margin-bottom: 5px;">${ins6}</li>
        </ul>
      </div>

        <div style="background-color: #add8e6; display: flex; justify-content: center; align-items: center; padding: 8px; border-radius: 10px;">
    <div style=" display: flex; justify-content: center; align-items: center; font-size: 12px; font-family: Times New Roman;">
      Thank You Please Visit Again
    </div>
  </div>
    </div>
  </div>
  `;

    element.innerHTML = content;

    // html2pdf()
    //   .set({
    //     margin: 0,
    //     filename: `Invoice-${invNo || invoiceNo}.pdf`,
    //     image: { type: "jpeg", quality: 0.98 },
    //     html2canvas: { scale: 2, useCORS: true },
    //     jsPDF: { unit: "mm", format: [90, 297], orientation: "portrait" },
    //   })
    //   .from(element)
    //   .save();
    const opt = {
      margin: [0, 5, 0, 5],
      filename: `Invoice-${invNo || invoiceNo}.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true },
      jsPDF: { unit: "mm", format: [90, 297], orientation: "portrait" },
    };

    const worker = html2pdf().set(opt).from(element);

    // Generate base64 string instead of downloading
    const base64String = await worker.outputPdf("datauristring");

    const rawBase64 = base64String?.replace(
      /^data:application\/pdf;filename=.*;base64,/,
      ""
    );
    setBase64(rawBase64);

    // Optionally: return it or send to API

    return base64String;
  };

  // useEffect(() => {
  //   if (!logo) return;

  //   // Fetch the image and convert it to base64
  //   fetch(logo)
  //     .then((res) => res.blob())
  //     .then((blob) => {
  //       const reader = new FileReader();
  //       reader.onloadend = () => {
  //         const base64String = reader.result;
  //         const pureBase64 = base64String.replace(
  //           /^data:image\/\w+;base64,/,
  //           ""
  //         );
  //         setBase64(pureBase64);
  //       };
  //       reader.readAsDataURL(blob);
  //     })
  //     .catch((err) => console.error("Error converting to base64:", err));
  // }, [logo]);

  const fetchWithRetry = async (url, retries = 3, delay = 300) => {
    for (let i = 0; i < retries; i++) {
      try {
        const res = await fetch(url, { mode: "cors" });
        if (res.ok) return res;
      } catch (e) {
        console.warn(`Retry ${i + 1} for ${url}`);
      }
      await new Promise((r) => setTimeout(r, delay));
    }
    throw new Error("Failed after retries: " + url);
  };

  const resizeBase64Img = (base64Str, maxWidth = 500, maxHeight = 500) =>
    new Promise((resolve) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        let width = img.width;
        let height = img.height;

        if (width > maxWidth || height > maxHeight) {
          if (width / height > maxWidth / maxHeight) {
            height *= maxWidth / width;
            width = maxWidth;
          } else {
            width *= maxHeight / height;
            height = maxHeight;
          }
        }

        canvas.width = width;
        canvas.height = height;
        ctx.drawImage(img, 0, 0, width, height);
        resolve(canvas.toDataURL("image/jpeg", 0.85));
      };
      img.src = base64Str;
    });

  const urlToBase64 = async (url) => {
    const cleanUrl = decodeURIComponent(url);
    const proxyUrl = `https://api.codetabs.com/v1/proxy?quest=${encodeURIComponent(
      cleanUrl
    )}`;

    const response = await fetchWithRetry(proxyUrl, 3, 800);
    const blob = await response.blob();

    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = async () => {
        try {
          const resized = await resizeBase64Img(reader.result);
          resolve(resized);
        } catch (err) {
          reject(err);
        }
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };

  // Usage inside useEffect for single image

  useEffect(() => {
    const convertImage = async () => {
      const imageUrl = singleImage ?? "";

      try {
        const base64 = await urlToBase64(imageUrl);
        setBase64Images(base64); // directly store base64 string
      } catch (err) {
        console.error("Image conversion failed:", err);
      }
    };

    convertImage();
  }, [singleImage]);

  // useEffect(() => {
  //   const convertImage = async () => {
  //     const imageUrl =
  //       "https://image.timeserasoftware.in/RETAILAPP/APPLOGO.jpeg";

  //     try {
  //       const base64 = await urlToBase64(imageUrl);
  //       setBase64Images(base64); // directly store base64 string
  //     } catch (err) {
  //       console.error("Image conversion failed:", err);
  //     }
  //   };

  //   convertImage();
  // }, []);

  const handleWhatsAppCancel = () => {
    setWhatsAppOpen(false);
  };
  const [ip, setIp] = useState("");

  useEffect(() => {
    fetch("https://api.ipify.org?format=json")
      .then((res) => res.json())
      .then((data) => setIp(data.ip))
      .catch((err) => console.error("IP fetch error", err));
  }, []);

  // const [localIp, setLocalIp] = useState("192.168.0.121");

  // useEffect(() => {
  //   getLocalIP()
  //     .then((ip) => setLocalIp(ip))
  //     .catch(console.error);
  // }, []);
  const handleEposPrint = (nextInvNo) => {
    printReceipt(
      localIp,
      address,
      address1,
      city,
      gstNo,
      userPhone,
      nextInvNo,
      invNo,
      billDate,
      userDetails,
      customerName,
      userName,
      customerMobile,
      barCodeData,
      totalAmount,
      totalDisAmt,
      totalNetAmt,
      totalQty,
      base64Images,
      base64QR,
      totalGstData,
      ins,
      ins1,
      ins2,
      ins3,
      ins4,
      ins5,
      ins6
    );
  };

  const handleBillPdfDownload = (nextInvNo) => {
    BillPdfDownload(
      address,
      address1,
      city,
      gstNo,
      userPhone,
      nextInvNo,
      invNo,
      billDate,
      userDetails,
      customerName,
      userName,
      customerMobile,
      barCodeData,
      totalAmount,
      totalDisAmt,
      totalNetAmt,
      totalQty,
      base64Images,
      base64QR,
      totalGstData,
      ins,
      ins1,
      ins2,
      ins3,
      ins4,
      ins5,
      ins6
    );
  };

  useEffect(() => {
    if (!totalNetAmt) return;

    const canvas = qrRef.current?.querySelector("canvas");
    if (canvas) {
      const base64 = canvas.toDataURL("image/png");
      setBase64QR(base64);
    }
  }, [totalNetAmt, upiLink]);

  useEffect(() => {
    const amount = totalNetAmt - cardAmt - upiAmt - onlineAmt - creditAmt;
    setCashAmt(amount);
  }, [totalNetAmt, cardAmt, upiAmt, onlineAmt, creditAmt]);

  const handleHomeBillSave = () => {
    if (Number(qty) === 0) {
      // message.warning("Design Code Not existed");
      message.open({
        type: "error",
        content: <div style={{ fontSize: "20px" }}>Check Quantity</div>,
      });
      return;
    }
    const homeData = [
      {
        ACITY: "-",
        AGENTNAME: "-",
        Area: "-",
        BOXES: null,
        BRANCHNAME: "-",
        CASERATECP: null,
        CASERATEDP: null,
        CASERATERP: null,
        CGSTAMT: 0,
        CGSTRATE: 0,
        COLOUR: "-",
        CPrice: rate,
        CTOKEN: 0,
        Code: "-",
        CompName: brandName,
        DPrice: 0,
        DesignCode: designCode,
        Disamt: disAmt,
        Disper: disCount,
        ECODE: "-",
        ENTRYDATE: "-",
        ENTRYNO: 0,
        EQTY: 0,
        EXPDATE: null,
        FITTING: "-",
        FLOOR: "-",
        FYEAR: "-",
        GST: 0,
        GSTAMT: 0,
        GrosDPrice: 0,
        GroupName: "-",
        HID: 0,
        HSNCODE: hsnCode,
        ICODETYPE: "-",
        IGSTAMT: 0,
        IGSTRATE: 0,
        InvNO: "-",
        Invdate: "-",
        ItemCode: "0",
        LASTBILLDATE: "-",
        LENGTH: null,
        LOOSEPCS: null,
        LQTY: null,
        OFFER_DIS: 0,
        OQTY2: 0,
        OQTY3: 0,
        OQTY4: null,
        PACKPCS: null,
        PNTMODEL: "-",
        PQTY: 0,
        PTYPE: pTypeName,
        Partyname: "-",
        ProdName: productName,
        Prodsize: "-",
        Qty: qty,
        RESELLERPRICE: null,
        RQTY: null,
        SEMIWSALERPRICE: null,
        SET_ITEMS: false,
        SGSTAMT: 0,
        SGSTRATE: 0,
        SLEVES: "-",
        SMODEL: "-",
        SNO: 0,
        TOKEN: 0,
        USTATUS: null,
        WPER: 0,
        WPRICE: 0,
        stock: qty,
        cloud_upload: false,
        mesure: null,
        offer: amount,
        taans: false,
      },
    ];
    setHomeDetailsOpen(false);
    setQty(0);
    setAmount(0);
    setDisCount(0);
    setRate(0);
    setDisAmt(0);
    setProductName("");
    setDesignCode("");
    setPTypeName("");
    setHsnCode("");
    setBrandName("");
    setProductData([]);
    setBarCodeData((prevData) => {
      let updatedData = [...prevData];

      const newItems = homeData.map((item) => {
        const gstItem = gstData.find((gst) => gst.PType === item.PTYPE);

        let appliedGST = 0;
        if (gstItem) {
          const offerAmount = item.offer ?? 0;
          if (offerAmount <= gstItem.BELLOWVALUE) {
            appliedGST = gstItem.BELLOWPER;
          } else if (offerAmount >= gstItem.ABOVEVALUE) {
            appliedGST = gstItem.ABOVEPER;
          }
        }

        return {
          ...item,
          // stock: 1,
          GSTApplied: appliedGST,
        };
      });

      // ✅ NO MERGE – ALWAYS ADD SEPARATE ENTRY
      newItems.forEach((newItem) => {
        // ❌ Stock validation
        if (newItem.stock > newItem.Qty) {
          message.open({
            type: "error",
            content: (
              <div style={{ fontSize: "18px" }}>
                Stock exceeded for Design Code {newItem.DesignCode}
              </div>
            ),
          });
          return;
        }

        updatedData.push(newItem);
      });

      // ================= TOTAL CALCULATIONS =================

      const totalBasic = updatedData.reduce((acc, item) => {
        const offer = Number(item.offer) || 0;
        const qty = Number(item.stock) || 0;
        const gst = Number(item.GSTApplied) || 0;
        const netAmt = qty * offer;
        return acc + netAmt * (100 / (100 + gst));
      }, 0);
      setTotalBasicAmount(totalBasic);

      const totalGst = updatedData.reduce((acc, item) => {
        const offer = Number(item.offer) || 0;
        const qty = Number(item.stock) || 0;
        const gst = Number(item.GSTApplied) || 0;
        const netAmt = qty * offer;
        const basic = netAmt * (100 / (100 + gst));
        return acc + basic * (gst / 100);
      }, 0);

      setTotalGstAmt(totalGst);
      setTotalCGSTAmt(totalGst / 2);
      setTotalSGSTAmt(totalGst / 2);

      const totalAmt = updatedData.reduce(
        (acc, item) =>
          acc + (Number(item.offer) || 0) * (Number(item.stock) || 0),
        0
      );

      setTotalAmount(totalAmt);

      const totalDisAmt = updatedData.reduce(
        (acc, item) => acc + (Number(item.Disamt) || 0),
        0
      );

      setTotalDisAmt(totalDisAmt);

      const grossAmt = totalAmt - totalDisAmt;
      // setTotalGrossAmount(grossAmt);
      // setTotalNetAmount(grossAmt);

      // ================= GST GROUPING =================

      const gstGroupedMap = new Map();

      updatedData.forEach((item) => {
        const key = item.GSTApplied;
        const netAmt = item.stock * item.offer;
        const basicAmt = netAmt * (100 / (100 + key));
        const gstAmt = (netAmt * (key / 100)) / 2;

        if (!gstGroupedMap.has(key)) {
          gstGroupedMap.set(key, {
            GST: key,
            CGST_RATE: key / 2,
            Basic_amt: 0,
            CGST_AMT: 0,
            SGST: key / 2,
            SGST_AMT: 0,
            NET_AMT: 0,
          });
        }

        const row = gstGroupedMap.get(key);
        row.Basic_amt += basicAmt;
        row.CGST_AMT += gstAmt;
        row.SGST_AMT += gstAmt;
        row.NET_AMT += netAmt;
      });

      setTotalGstData(Array.from(gstGroupedMap.values()));

      return updatedData;
    });
  };

  const handleTaansBillSave = () => {
    if (Number(taansData[0]?.stock) === 0) {
      // message.warning("Design Code Not existed");
      message.open({
        type: "error",
        content: <div style={{ fontSize: "20px" }}>Check Quantity</div>,
      });
      return;
    }
    setTaansOpen(false);
    setTaansData([]);
    setBarCodeData((prevData) => {
      let updatedData = [...prevData];

      const newItems = taansData.map((item) => {
        const gstItem = gstData.find((gst) => gst.PType === item.PTYPE);

        let appliedGST = 0;
        if (gstItem) {
          const offerAmount = item.offer ?? 0;
          if (offerAmount <= gstItem.BELLOWVALUE) {
            appliedGST = gstItem.BELLOWPER;
          } else if (offerAmount >= gstItem.ABOVEVALUE) {
            appliedGST = gstItem.ABOVEPER;
          }
        }

        return {
          ...item,
          // stock: 1,
          GSTApplied: appliedGST,
        };
      });

      // ✅ NO MERGE – ALWAYS ADD SEPARATE ENTRY
      newItems.forEach((newItem) => {
        // ❌ Stock validation
        if (newItem.stock > newItem.Qty) {
          message.open({
            type: "error",
            content: (
              <div style={{ fontSize: "18px" }}>
                Stock exceeded for Design Code {newItem.DesignCode}
              </div>
            ),
          });
          return;
        }

        updatedData.push(newItem);
      });

      // ================= TOTAL CALCULATIONS =================

      const totalGst = updatedData.reduce((acc, item) => {
        const offer = Number(item.offer) || 0;
        const qty = Number(item.stock) || 0;
        const gst = Number(item.GSTApplied) || 0;
        return acc + offer * qty * (gst / 100);
      }, 0);

      setTotalGstAmt(totalGst);
      setTotalCGSTAmt(totalGst / 2);
      setTotalSGSTAmt(totalGst / 2);

      const totalAmt = updatedData.reduce(
        (acc, item) =>
          acc + (Number(item.offer) || 0) * (Number(item.stock) || 0),
        0
      );

      setTotalAmount(totalAmt);

      const totalDisAmt = updatedData.reduce(
        (acc, item) => acc + (Number(item.Disamt) || 0),
        0
      );

      setTotalDisAmt(totalDisAmt);

      const grossAmt = totalAmt - totalDisAmt;
      // setTotalGrossAmount(grossAmt);
      // setTotalNetAmount(grossAmt);

      // ================= GST GROUPING =================

      const gstGroupedMap = new Map();

      updatedData.forEach((item) => {
        const key = item.GSTApplied;
        const netAmt = item.stock * item.offer;
        const basicAmt = netAmt * (100 / (100 + key));
        const gstAmt = (netAmt * (key / 100)) / 2;

        if (!gstGroupedMap.has(key)) {
          gstGroupedMap.set(key, {
            GST: key,
            CGST_RATE: key / 2,
            Basic_amt: 0,
            CGST_AMT: 0,
            SGST: key / 2,
            SGST_AMT: 0,
            NET_AMT: 0,
          });
        }

        const row = gstGroupedMap.get(key);
        row.Basic_amt += basicAmt;
        row.CGST_AMT += gstAmt;
        row.SGST_AMT += gstAmt;
        row.NET_AMT += netAmt;
      });

      setTotalGstData(Array.from(gstGroupedMap.values()));

      return updatedData;
    });
  };

  const handleOfferABillSave = () => {
    if (Number(offerAData[0]?.stock) === 0) {
      // message.warning("Design Code Not existed");
      message.open({
        type: "error",
        content: <div style={{ fontSize: "20px" }}>Check Quantity</div>,
      });
      return;
    }
    setOfferAOpen(false);
    setOfferAData([]);
    setBarCodeData((prevData) => {
      let updatedData = [...prevData];

      const newItems = offerAData.map((item) => {
        const gstItem = gstData.find((gst) => gst.PType === item.PTYPE);

        let appliedGST = 0;
        if (gstItem) {
          const offerAmount = item.offer ?? 0;
          if (offerAmount <= gstItem.BELLOWVALUE) {
            appliedGST = gstItem.BELLOWPER;
          } else if (offerAmount >= gstItem.ABOVEVALUE) {
            appliedGST = gstItem.ABOVEPER;
          }
        }

        return {
          ...item,
          // stock: 1,
          GSTApplied: appliedGST,
        };
      });

      // ✅ NO MERGE – ALWAYS ADD SEPARATE ENTRY
      newItems.forEach((newItem) => {
        // ❌ Stock validation
        if (newItem.stock > newItem.Qty) {
          message.open({
            type: "error",
            content: (
              <div style={{ fontSize: "18px" }}>
                Stock exceeded for Design Code {newItem.DesignCode}
              </div>
            ),
          });
          return;
        }

        updatedData.push(newItem);
      });

      // ================= TOTAL CALCULATIONS =================

      const totalBasic = updatedData.reduce((acc, item) => {
        const offer = Number(item.offer) || 0;
        const qty = Number(item.stock) || 0;
        const gst = Number(item.GSTApplied) || 0;
        const netAmt = qty * offer;
        return acc + netAmt * (100 / (100 + gst));
      }, 0);
      setTotalBasicAmount(totalBasic);

      const totalGst = updatedData.reduce((acc, item) => {
        const offer = Number(item.offer) || 0;
        const qty = Number(item.stock) || 0;
        const gst = Number(item.GSTApplied) || 0;
        const netAmt = qty * offer;
        const basic = netAmt * (100 / (100 + gst));
        return acc + basic * (gst / 100);
      }, 0);

      setTotalGstAmt(totalGst);
      setTotalCGSTAmt(totalGst / 2);
      setTotalSGSTAmt(totalGst / 2);

      // const totalAmt = updatedData.reduce(
      //   (acc, item) =>
      //     acc + (Number(item.offer) || 0) * (Number(item.stock) || 0),
      //   0
      // );

      // setTotalAmount(totalAmt);

      const totalDisAmt = updatedData.reduce(
        (acc, item) => acc + (Number(item.Disamt) || 0),
        0
      );

      setTotalDisAmt(totalDisAmt);

      // const grossAmt = totalAmt - totalDisAmt;
      // setTotalGrossAmount(grossAmt);
      // setTotalNetAmount(grossAmt);

      // ================= GST GROUPING =================

      const gstGroupedMap = new Map();

      updatedData.forEach((item) => {
        const key = item.GSTApplied;
        const netAmt = item.stock * item.offer;
        const basicAmt = netAmt * (100 / (100 + key));
        const gstAmt = (netAmt * (key / 100)) / 2;

        if (!gstGroupedMap.has(key)) {
          gstGroupedMap.set(key, {
            GST: key,
            CGST_RATE: key / 2,
            Basic_amt: 0,
            CGST_AMT: 0,
            SGST: key / 2,
            SGST_AMT: 0,
            NET_AMT: 0,
          });
        }

        const row = gstGroupedMap.get(key);
        row.Basic_amt += basicAmt;
        row.CGST_AMT += gstAmt;
        row.SGST_AMT += gstAmt;
        row.NET_AMT += netAmt;
      });

      setTotalGstData(Array.from(gstGroupedMap.values()));

      return updatedData;
    });
  };

  const handleOfferBBillSave = () => {
    if (Number(offerBData[0]?.stock) === 0) {
      // message.warning("Design Code Not existed");
      message.open({
        type: "error",
        content: <div style={{ fontSize: "20px" }}>Check Quantity</div>,
      });
      return;
    }
    setOfferBOpen(false);
    setOfferBData([]);
    setBarCodeData((prevData) => {
      let updatedData = [...prevData];

      const newItems = offerBData.map((item) => {
        const gstItem = gstData.find((gst) => gst.PType === item.PTYPE);

        let appliedGST = 0;
        if (gstItem) {
          const offerAmount = item.offer ?? 0;
          if (offerAmount <= gstItem.BELLOWVALUE) {
            appliedGST = gstItem.BELLOWPER;
          } else if (offerAmount >= gstItem.ABOVEVALUE) {
            appliedGST = gstItem.ABOVEPER;
          }
        }

        return {
          ...item,
          // stock: 1,
          GSTApplied: appliedGST,
        };
      });

      // ✅ NO MERGE – ALWAYS ADD SEPARATE ENTRY
      newItems.forEach((newItem) => {
        // ❌ Stock validation
        if (newItem.stock > newItem.Qty) {
          message.open({
            type: "error",
            content: (
              <div style={{ fontSize: "18px" }}>
                Stock exceeded for Design Code {newItem.DesignCode}
              </div>
            ),
          });
          return;
        }

        updatedData.push(newItem);
      });

      // ================= TOTAL CALCULATIONS =================

      const totalBasic = updatedData.reduce((acc, item) => {
        const offer = Number(item.offer) || 0;
        const qty = Number(item.stock) || 0;
        const gst = Number(item.GSTApplied) || 0;
        const netAmt = qty * offer;
        return acc + netAmt * (100 / (100 + gst));
      }, 0);
      setTotalBasicAmount(totalBasic);

      const totalGst = updatedData.reduce((acc, item) => {
        const offer = Number(item.offer) || 0;
        const qty = Number(item.stock) || 0;
        const gst = Number(item.GSTApplied) || 0;
        const netAmt = qty * offer;
        const basic = netAmt * (100 / (100 + gst));
        return acc + basic * (gst / 100);
      }, 0);

      setTotalGstAmt(totalGst);
      setTotalCGSTAmt(totalGst / 2);
      setTotalSGSTAmt(totalGst / 2);

      // const totalAmt = updatedData.reduce(
      //   (acc, item) =>
      //     acc + (Number(item.offer) || 0) * (Number(item.stock) || 0),
      //   0
      // );

      // setTotalAmount(totalAmt);

      const totalDisAmt = updatedData.reduce(
        (acc, item) => acc + (Number(item.Disamt) || 0),
        0
      );

      setTotalDisAmt(totalDisAmt);

      // const grossAmt = totalAmt - totalDisAmt;
      // setTotalGrossAmount(grossAmt);
      // setTotalNetAmount(grossAmt);

      // ================= GST GROUPING =================

      const gstGroupedMap = new Map();

      updatedData.forEach((item) => {
        const key = item.GSTApplied;
        const netAmt = item.stock * item.offer;
        const basicAmt = netAmt * (100 / (100 + key));
        const gstAmt = (netAmt * (key / 100)) / 2;

        if (!gstGroupedMap.has(key)) {
          gstGroupedMap.set(key, {
            GST: key,
            CGST_RATE: key / 2,
            Basic_amt: 0,
            CGST_AMT: 0,
            SGST: key / 2,
            SGST_AMT: 0,
            NET_AMT: 0,
          });
        }

        const row = gstGroupedMap.get(key);
        row.Basic_amt += basicAmt;
        row.CGST_AMT += gstAmt;
        row.SGST_AMT += gstAmt;
        row.NET_AMT += netAmt;
      });

      setTotalGstData(Array.from(gstGroupedMap.values()));

      return updatedData;
    });
  };

  const handleTagNoKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      submitRef.current?.click();
    }
  };

  const handleMobileNoKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      searchRef.current?.click();
    }
  };

  return (
    <div>
      {contextHolder}
      <Header setOpen={setOpen} />
      <SidebarDrawer
        open={open}
        toggleDrawer={toggleDrawer}
        singleImage={singleImage}
        userArea={userArea}
        userName={userName}
      />

      <div className={styles.container}>
        <div ref={qrRef} style={{ display: "none" }}>
          <QRCodeCanvas value={upiLink} size={200} includeMargin={true} />
        </div>
        <div className={styles.headerContainer}>
          <h3 className={styles.heading}>INVOICE</h3>
          <div className={styles.rateCard}>
            <div className={styles.left}>
              <span className={styles.amount}>{invNo ? invNo : invoiceNo}</span>
              <span className={styles.date}>
                {billDate
                  ? dayjs(billDate).format("DD-MMM-YYYY")
                  : dayjs().format("DD-MMM-YYYY")}
              </span>
            </div>
            <AutoFixHighSharpIcon
              className={styles.modifyIcon}
              onClick={handleModifyOpen}
            />
            <ContactPhoneSharpIcon
              className={styles.infoIcon}
              onClick={() => {
                setCustOpen(true);
              }}
            />
          </div>
        </div>

        <div className={styles.estimationTagContainer}>
          <div className={styles.tagNoSection}>
            <span className={styles.tagLabel}>Design Code</span>
            <Input
              ref={tagNoRef}
              autoFocus={true}
              className={styles.tagInput}
              value={scanResult}
              onKeyDown={handleTagNoKeyDown}
              onChange={(e) => {
                const filtered = e.target.value
                  .toUpperCase()
                  .replace(/[^A-Z0-9]/g, "");
                setScanResult(filtered);
              }}
            />
          </div>

          <div className={styles.buttonSection}>
            <Button
              type="primary"
              htmlType="submit"
              ref={submitRef}
              className={styles.submitButton}
              onClick={() => {
                if (!scanResult) {
                  message.warning("Enter Design Code");
                } else {
                  mainAPI();
                  homeBillData();
                }
              }}
            >
              Submit
            </Button>
            <Button
              type="primary"
              danger
              className={styles.resetButton}
              onClick={handleRest}
            >
              Reset
            </Button>
            {whatsAppCheck === true ? (
              <WhatsAppIcon
                style={{ color: "#0bbf41", height: "35px", width: "35px" }}
              />
            ) : (
              ""
            )}
            <div
              onClick={handleToggleScan}
              style={{ width: "20px", height: "20px" }}
            >
              <ScanOutlined
                style={{
                  fontSize: "25px",
                  color: scanOpen === true ? "#162566" : "#eb14bcff",
                }}
              />
            </div>
          </div>
        </div>
        <div
          className={styles.estimationContainer}
          style={{
            flexDirection: "row", // changed to row for side by side layout
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          {/* Left Side: Original content */}
          <div
            style={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <div
              style={{
                fontSize: "18px",
                fontWeight: "bold",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                background: "#162566",
                borderRadius: "8px",
                padding: "4px 20px 4px 10px",
                width: "90%",
                marginBottom: "10px",
              }}
            >
              <span style={{ color: "white", margin: "0 auto" }}>Total</span>
              <span
                style={{
                  fontSize: "14px",
                  color: "white",
                  fontWeight: "bold",
                }}
              >
                QTY:{" "}
                <span
                  style={{
                    color: "white",
                    fontWeight: "bold",
                    fontSize: "16px",
                  }}
                >
                  {totalQty}
                </span>
              </span>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: "8px",
                  width: "100%",
                }}
              >
                {/* Gross Amount */}
                <style>
                  {`
      @keyframes pulseShrink {
        0% {
          transform: scale(1);
          text-shadow: 0 0 5px rgba(246, 245, 243, 0.4);
        }
        50% {
          transform: scale(0.92);
          text-shadow: 0 0 15px rgba(250, 249, 249, 0.7);
        }
        100% {
          transform: scale(1);
          text-shadow: 0 0 5px rgba(248, 248, 247, 0.4);
        }
      }
    `}
                </style>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "0 15px",
                  }}
                >
                  <div style={{ textAlign: "center" }}>
                    <div style={{ fontSize: "12px", color: "black" }}>
                      Gross. Amt
                    </div>
                    <div
                      style={{
                        color: "black",
                        fontWeight: "bold",
                        fontSize: "13px",
                        marginTop: "8px",
                        background: "linear-gradient(90deg, #000, #000, #000)",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                        animation: "pulseShrink 0.3s ease-in-out infinite",
                        transition:
                          "transform 0.3s ease, text-shadow 0.3s ease",
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.transform = "scale(1.1)";
                        e.target.style.textShadow =
                          "0 0 20px rgba(255, 100, 0, 0.8)";
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.transform = "";
                        e.target.style.textShadow = "";
                      }}
                    >
                      {"₹" + " " + totalAmount?.toFixed(2)}
                    </div>
                  </div>
                </div>

                <div
                  style={{
                    width: "2px",
                    height: "35px",
                    backgroundColor: "#162566",
                  }}
                ></div>

                {/* Discount Amount */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "0 15px",
                  }}
                >
                  <div style={{ textAlign: "center" }}>
                    <div style={{ fontSize: "12px", color: "black" }}>
                      Dis. Amt
                    </div>
                    <div
                      style={{
                        color: "black",
                        fontWeight: "bold",
                        fontSize: "13px",
                        marginTop: "8px",
                        background: "linear-gradient(90deg, #000, #000, #000)",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                        animation: "pulseShrink 0.3s ease-in-out infinite",
                        transition:
                          "transform 0.3s ease, text-shadow 0.3s ease",
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.transform = "scale(1.1)";
                        e.target.style.textShadow =
                          "0 0 20px rgba(255, 100, 0, 0.8)";
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.transform = "";
                        e.target.style.textShadow = "";
                      }}
                    >
                      {"₹" + " " + totalDisAmt?.toFixed(2)}
                    </div>
                  </div>
                </div>

                <div
                  style={{
                    width: "2px",
                    height: "35px",
                    backgroundColor: "#162566",
                  }}
                ></div>

                {/* Net Amount */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "0 15px",
                  }}
                >
                  <div style={{ textAlign: "center" }}>
                    <div style={{ fontSize: "12px", color: "black" }}>
                      Net. Amt
                    </div>
                    <div
                      style={{
                        color: "black",
                        fontWeight: "bold",
                        fontSize: "18px",
                        marginTop: "8px",
                        background: "linear-gradient(90deg, #000, #000, #000)",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                        animation: "pulseShrink 0.3s ease-in-out infinite",
                        transition:
                          "transform 0.3s ease, text-shadow 0.3s ease",
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.transform = "scale(1.1)";
                        e.target.style.textShadow =
                          "0 0 20px rgba(255, 100, 0, 0.8)";
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.transform = "";
                        e.target.style.textShadow = "";
                      }}
                    >
                      {"₹" + " " + totalNetAmt?.toFixed(2)}
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.leftSection}>
                <div className={styles.dateContainer}>
                  <Button
                    style={{
                      fontSize: "12px",
                      fontWeight: "bold",
                      marginRight: "5px",
                      backgroundColor: "#162566",
                      color: "white",
                      borderRadius: "5px",
                      padding: "5px 10px",
                      width: "80px",
                      border: "1px solid #162566",
                    }}
                    onClick={async () => {
                      tagNoRef.current?.focus();
                      if (!barCodeData?.length) {
                        messageApi.open({
                          type: "error",
                          content: (
                            <span style={{ fontSize: "18px", fontWeight: 600 }}>
                              Please add Design Details.
                            </span>
                          ),
                        });
                        return;
                      }

                      // ❌ Credit sale without customer details
                      if (
                        cashValue === "CREDIT" &&
                        (!customerName || !customerArea || !customerMobile)
                      ) {
                        messageApi.open({
                          type: "error",
                          content: (
                            <span style={{ fontSize: "18px", fontWeight: 600 }}>
                              Please enter customer details for CREDIT bill.
                            </span>
                          ),
                        });
                        return;
                      }
                      // if (barCodeData.length > 0) {
                      try {
                        if (invNo) {
                          await createStockAddAPI();
                          await deleteBarcodeMastAPI();
                          await deleteBarcodeDetAPI();
                          await deleteBarcodeDataAPI();
                          await deleteBarcodePayModeAPI();
                          await deleteBarcodeOnlinePayAPI();
                          await deleteBarcodeLedgerAPI();
                          await createBarcodeData();
                          await createBarcodeDet();
                          await createStockUpdateAPI();
                          await paymentModeAPI();
                          await createLedgerBalanceAPI();
                          if (
                            (barCodeData.length > 0 && cashValue === "CARD") ||
                            cashValue === "UPI" ||
                            cashValue === "ONLINE"
                          ) {
                            await onlinePayModeAPI();
                          }
                          if (whatsAppCheck === true) {
                            await sendWhatsAppAPI();
                          }
                          await createBarcodeMast();
                        } else {
                          const nextInvNo = await invoiceCountAPI();
                          await createBarcodeData(nextInvNo);
                          await createBarcodeDet(nextInvNo);
                          await createStockUpdateAPI();
                          await paymentModeAPI(nextInvNo);
                          await createLedgerBalanceAPI();
                          if (
                            (barCodeData.length > 0 && cashValue === "CARD") ||
                            cashValue === "UPI" ||
                            cashValue === "ONLINE"
                          ) {
                            await onlinePayModeAPI(nextInvNo);
                          }
                          if (whatsAppCheck === true) {
                            await sendWhatsAppAPI();
                          }
                          await createBarcodeMast(nextInvNo);
                        }

                        setBase64();
                      } catch (error) {
                        console.error("Error creating bill:", error);
                        messageApi.open({
                          type: "error",
                          content: (
                            <span style={{ fontSize: "18px", fontWeight: 600 }}>
                              Something went wrong while creating the bill.
                            </span>
                          ),
                        });
                      }
                      // }
                    }}
                  >
                    SAVE
                  </Button>
                  <Button
                    style={{
                      fontSize: "12px",
                      fontWeight: "bold",
                      marginRight: "5px",
                      backgroundColor: "orange",
                      color: "white",
                      borderRadius: "5px",
                      padding: "5px 10px",
                      width: "80px",
                      border: "1px solid orange",
                    }}
                    onClick={async () => {
                      tagNoRef.current?.focus();
                      if (!barCodeData?.length) {
                        messageApi.open({
                          type: "error",
                          content: (
                            <span style={{ fontSize: "18px", fontWeight: 600 }}>
                              Please add Design Details.
                            </span>
                          ),
                        });
                        return;
                      }

                      // ❌ Credit sale without customer details
                      if (
                        cashValue === "CREDIT" &&
                        (!customerName || !customerArea || !customerMobile)
                      ) {
                        messageApi.open({
                          type: "error",
                          content: (
                            <span style={{ fontSize: "18px", fontWeight: 600 }}>
                              Please enter customer details for CREDIT bill.
                            </span>
                          ),
                        });
                        return;
                      }
                      // if (barCodeData.length > 0) {
                      try {
                        if (pdfModule === "WIFI") {
                          const nextInvNo = await invoiceCountAPI();
                          handleEposPrint(nextInvNo);
                        } else {
                          const nextInvNo = await invoiceCountAPI();
                          handleBillPdfDownload(nextInvNo);
                        }
                        if (invNo) {
                          await createStockAddAPI();
                          await deleteBarcodeMastAPI();
                          await deleteBarcodeDetAPI();
                          await deleteBarcodeDataAPI();
                          await deleteBarcodePayModeAPI();
                          await deleteBarcodeOnlinePayAPI();
                          await deleteBarcodeLedgerAPI();
                          await createBarcodeData();
                          await createBarcodeDet();
                          await createStockUpdateAPI();
                          await paymentModeAPI();
                          await createLedgerBalanceAPI();
                          if (
                            (barCodeData.length > 0 && cashValue === "CARD") ||
                            cashValue === "UPI" ||
                            cashValue === "ONLINE"
                          ) {
                            await onlinePayModeAPI();
                          }
                          await createBarcodeMast();
                        } else {
                          const nextInvNo = await invoiceCountAPI();
                          await createBarcodeData(nextInvNo);
                          await createBarcodeDet(nextInvNo);
                          await createStockUpdateAPI();
                          await paymentModeAPI(nextInvNo);
                          await createLedgerBalanceAPI();
                          if (
                            (barCodeData.length > 0 && cashValue === "CARD") ||
                            cashValue === "UPI" ||
                            cashValue === "ONLINE"
                          ) {
                            await onlinePayModeAPI(nextInvNo);
                          }
                          if (whatsAppCheck === true) {
                            await sendWhatsAppAPI();
                          }
                          await createBarcodeMast(nextInvNo);
                        }

                        setBase64();
                      } catch (error) {
                        console.error("Error creating bill:", error);
                        messageApi.open({
                          type: "error",
                          content: (
                            <span style={{ fontSize: "18px", fontWeight: 600 }}>
                              Something went wrong while creating the bill.
                            </span>
                          ),
                        });
                      }
                      // }
                    }}
                  >
                    PRINT
                  </Button>
                  {/* <WhatsAppIcon
                    style={{
                      fontSize: "40px",
                      color: "#52bd91",
                      backgroundColor: "white",
                      borderRadius: "50%",
                    }}
                  /> */}
                  {barCodeData.length > 0 && (
                    <PaymentsOutlinedIcon
                      style={{ fontSize: "40px", marginLeft: "10px" }}
                      onClick={handleCashOpen}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Right Side: Payments Icon */}
          {/* <div>
            <PaymentsOutlinedIcon
              style={{ fontSize: "40px", color: "#162566" }}
            />
          </div> */}
        </div>
      </div>
      <div className={styles.containerData}>
        {/* <div
          style={{
            fontSize: "18px",
            fontWeight: "bold",
            display: "flex",
            justifyContent: "center",
            background: "lightblue",
            borderRadius: "8px",
            padding: "6px 0px 2px 0px",
            width: "100%",
            marginBottom: "5px",
          }}
        > */}
        {/* <span
          style={{
            fontSize: "16px",
            fontWeight: "bold",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            background: "#162566",
            borderRadius: "8px",
            padding: "6px 12px 2px 12px",
            width: "90%",
            marginBottom: "5px",
            color: "white",
          }}
        >
          <span>Product Details</span>

          {barCodeData.length > 0 && (
            <span
              style={{
                fontWeight: "bold",
                fontSize: "20px",
                background: "#fff",
                borderRadius: "8px",
                padding: "4px 8px",
                border: "2px solid #fff",
                color: "#e62914ff",
              }}
            >
              {barCodeData.length}
            </span>
          )}

          <ArrowDropDownOutlinedIcon
            style={{
              fontSize: "30px",
              color: "red",
            }}
          />
        </span> */}
        <div
          style={{
            fontSize: "16px",
            fontWeight: "bold",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            background: "#162566",
            // borderRadius: "8px",
            padding: "8px 12px",
            color: "white",
            position: "sticky",
            top: 0,
            zIndex: 10,
          }}
        >
          <span>Product Details</span>

          {barCodeData.length > 0 && (
            <span
              style={{
                fontSize: "18px",
                background: "#fff",
                borderRadius: "8px",
                padding: "4px 8px",
                color: "#e62914",
              }}
            >
              {barCodeData.length}
            </span>
          )}

          <ArrowDropDownOutlinedIcon style={{ fontSize: 28, color: "red" }} />
        </div>
        {/* </div> */}
        {barCodeData.length === 0 ? (
          <div style={{ textAlign: "center", padding: "20px" }}>
            <img
              src={noData}
              alt="No Data"
              style={{ width: "100px", opacity: 0.7 }}
            />
            <p style={{ color: "#999", marginTop: "10px" }}>No Data Found</p>
          </div>
        ) : (
          barCodeData.map((code, index) => (
            <div
              key={code.id}
              style={{
                display: "flex",
                justifyContent: "space-between",
                // border: "1px solid #000",
                padding: "5px",
                marginBottom: "10px",
                borderRadius: "8px",
                fontFamily: "sans-serif",
                fontSize: "14px",
                boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.22)",
                background:
                  "radial-gradient(circle at center, #ffffff 40%, #f3f6fb 60%, #e0e7f1 80%)",
              }}
            >
              {/* LEFT SIDE */}
              <div style={{ width: "60%", padding: "0 5px" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    fontSize: "14px",
                    color: "#555",
                    marginBottom: "3px",
                    background: "#52bd91",
                    borderRadius: "8px",
                    padding: "4px 8px",
                  }}
                >
                  <span
                    style={{
                      color: "black",
                      fontWeight: "bold",
                      fontSize: "16px",
                    }}
                  >
                    {code.DesignCode}
                  </span>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    fontSize: "14px",
                    color: "#555",
                    marginBottom: "5px",
                  }}
                >
                  <span
                    style={{
                      color: "#162566",
                      fontWeight: "bold",
                      fontSize: "12px",
                    }}
                  >
                    {code.ProdName}
                  </span>
                </div>
                <div
                  style={{
                    // display: "flex",
                    // justifyContent: "space-between",
                    alignItems: "center",
                    fontSize: "14px",
                    color: "#555",
                    marginBottom: "5px",
                  }}
                >
                  MRP :{" "}
                  <span
                    style={{
                      color: "#162566",
                      fontWeight: "bold",
                      fontSize: "14px",
                    }}
                  >
                    {code.CPrice.toFixed(2)}
                  </span>
                </div>
                <div
                  style={{
                    // display: "flex",
                    // justifyContent: "space-between",
                    alignItems: "center",
                    fontSize: "14px",
                    color: "#555",
                    marginBottom: "5px",
                  }}
                >
                  Discount :{" "}
                  <span
                    style={{
                      color: "#162566",
                      fontWeight: "bold",
                      fontSize: "14px",
                    }}
                  >
                    {code.Disper + "%"}
                  </span>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    fontSize: "14px",
                    color: "#555",
                    marginBottom: "5px",
                  }}
                >
                  Dis.Amt :{" "}
                  <span
                    style={{
                      color: "#162566",
                      fontWeight: "bold",
                      fontSize: "14px",
                    }}
                  >
                    {code.Disamt.toFixed(2)}
                  </span>
                  <span>
                    <HistoryEduIcon
                      style={{ fontSize: "20px", color: "green" }}
                      onClick={() => {
                        handleCardOpen(code);
                      }}
                    />
                  </span>
                </div>
                {/* <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  fontSize: "14px",
                  color: "#555",
                  marginBottom: "6px",
                }}
              >
                SM.Code: <strong></strong>
              </div> */}
              </div>

              {/* RIGHT SIDE */}
              <div
                style={{
                  width: "60%",
                  borderLeft: "2.5px solid #d6d6d6",
                  paddingLeft: "10px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    flexDirection: "row-reverse",
                    fontSize: "14px",
                    color: "#555",
                    marginBottom: "5px",
                  }}
                >
                  <span
                    style={{
                      color: "red",
                      fontWeight: "bold",
                      fontSize: "18px",
                    }}
                  >
                    <DeleteOutlined
                      style={{
                        color: "red",
                        cursor: "pointer",
                        fontSize: "20px",
                      }}
                      onClick={() => handleDelete(index)}
                    />
                  </span>

                  <span
                    style={{
                      color: "white",
                      fontWeight: "bold",
                      fontSize: "18px",
                      background: "#ea0e41",
                      borderRadius: "50%",
                      padding: "4px 8px",
                    }}
                  >
                    #{index + 1}
                  </span>
                </div>
                {/* {code?.SMODEL === "A" ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "14px",
                      color: "#555",
                      marginBottom: "5px",
                    }}
                  >
                    QTY :
                    <button
                      onClick={() =>
                        handleQtyAChange(
                          index,
                          code.stock - 1,
                          code?.OQTY3,
                          code?.OQTY2
                        )
                      }
                      disabled={code.stock <= 1}
                    >
                      ➖
                    </button>
                    <span style={{ fontWeight: "bold", fontSize: "16px" }}>
                      {code.stock}
                    </span>
                    <button
                      onClick={() =>
                        handleQtyAChange(
                          index,
                          code.stock + 1,
                          code?.OQTY3,
                          code?.OQTY2
                        )
                      }
                      disabled={code.stock >= 3}
                    >
                      ➕
                    </button>
                  </div>
                ) : code?.SMODEL === "B" ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "14px",
                      color: "#555",
                      marginBottom: "5px",
                    }}
                  >
                    QTY :
                    <button
                      onClick={() =>
                        handleQtyBChange(
                          index,
                          code.stock - 1,
                          code?.OQTY3,
                          code?.OQTY2,
                          code?.CPrice
                        )
                      }
                      disabled={code.stock <= 1}
                    >
                      ➖
                    </button>
                    <span style={{ fontWeight: "bold", fontSize: "16px" }}>
                      {code.stock}
                    </span>
                    <button
                      onClick={() =>
                        handleQtyBChange(
                          index,
                          code.stock + 1,
                          code?.OQTY3,
                          code?.OQTY2,
                          code?.CPrice
                        )
                      }
                      disabled={code.stock >= 3}
                    >
                      ➕
                    </button>
                  </div>
                ) : ( */}
                <div
                  style={{
                    alignItems: "center",
                    fontSize: "14px",
                    color: "#555",
                    marginBottom: "5px",
                  }}
                  onClick={() => {
                    setItemDetailsOpen(true);
                    setItemDetailsData(code);
                    setItemDEsignCode(index);
                  }}
                >
                  QTY :{" "}
                  <strong style={{ fontSize: "16px" }}>{code.stock}</strong>{" "}
                  <span style={{ color: "#152565", fontSize: "12px" }}>
                    (Click Here)
                  </span>
                  {/* <button
                    onClick={() => handleQtyChange(index, code.stock - 1)}
                    disabled={code.stock <= 1}
                  >
                    ➖
                  </button>
                  <span style={{ fontWeight: "bold", fontSize: "16px" }}>
                    {code.stock}
                  </span>
                  <button
                    onClick={() => handleQtyChange(index, code.stock + 1)}
                    disabled={code.stock >= code.Qty}
                  >
                    ➕
                  </button> */}
                </div>
                {/* )} */}
                {/* <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    fontSize: "14px",
                    color: "#555",
                    marginBottom: "5px",
                  }}
                >
                  QTY :
                  <button
                    onClick={() =>
                      handleQtyChange(
                        index,
                        code.stock - 1,
                        code?.SMODEL,
                        code?.OQTY3,
                        code?.OQTY2,
                        code?.CPrice
                      )
                    }
                    disabled={code.stock <= 1}
                  >
                    ➖
                  </button>
                  <span style={{ fontWeight: "bold", fontSize: "16px" }}>
                    {code.stock}
                  </span>
                  <button
                    onClick={() =>
                      handleQtyChange(
                        index,
                        code.stock + 1,
                        code?.SMODEL,
                        code?.OQTY3,
                        code?.OQTY2,
                        code?.CPrice
                      )
                    }
                    disabled={code.stock >= code.Qty}
                  >
                    ➕
                  </button>
                </div> */}
                <div
                  style={{
                    // display: "flex",
                    // justifyContent: "space-between",
                    alignItems: "center",
                    fontSize: "14px",
                    color: "#555",
                    marginBottom: "5px",
                  }}
                >
                  Rate :{" "}
                  <strong style={{ fontSize: "16px" }}>
                    {code.offer.toFixed(2)}
                  </strong>
                </div>
                <div
                  style={{
                    // display: "flex",
                    // justifyContent: "space-between",
                    alignItems: "center",
                    fontSize: "14px",
                    marginBottom: "5px",
                    background: "#162566",
                    borderRadius: "8px",
                    padding: "4px 8px",
                  }}
                >
                  <span style={{ fontSize: "14px", color: "white" }}>
                    Amt :{" "}
                  </span>
                  <strong style={{ fontSize: "16px", color: "white" }}>
                    {Number(code.stock * code.offer).toFixed(2)}
                  </strong>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
      <>
        {scanOpen === true && (
          <>
            {!qrOpen && (
              <div
                className={styles.scanIconContainer}
                onClick={handleOpenScanner}
              >
                <QrCodeScannerIcon style={{ fontSize: 30, color: "white" }} />
              </div>
            )}
          </>
        )}
        {qrOpen && (
          <div className={styles.qrScannerOverlay}>
            <div className={styles.qrScannerContent}>
              <div className={styles.closeIcon} onClick={stopScanner}>
                <CloseIcon style={{ fontSize: 30, color: "#fff" }} />
              </div>
              <div
                id="qr-reader"
                style={{ width: "300px", height: "300px" }}
              ></div>
            </div>
          </div>
        )}
      </>
      {/* <UPIQrGenerator /> */}
      <CustomerInformation
        customerOpen={customerOpen}
        setCustomerOpen={setCustomerOpen}
        handleOk={handleOk}
        handleCancel={handleCancel}
        customerArea={customerArea}
        setCustomerArea={setCustomerArea}
        customerName={customerName}
        setCustomerName={setCustomerName}
        customerMobile={customerMobile}
        setCustomerMobile={setCustomerMobile}
      />
      <CustomerDialog
        open={custOpen}
        onCancel={() => {
          setCustOpen(false);
          tagNoRef.current?.focus();
        }}
        onSave={createCustomerDetailsAPI}
        formValues={formValues}
        setFormValues={setFormValues}
        deleteCustomerDetailsAPI={deleteCustomerDetailsAPI}
        phoneNo={phoneNo}
        setPhoneNo={setPhoneNo}
        userDetailsAPI={userDetailsAPI}
        phone1Ref={mobileRef}
        searchRef={searchRef}
        handleMobileNoKeyDown={handleMobileNoKeyDown}
      />
      <SingleCardDetails
        cardOpen={cardOpen}
        setCardOpen={setCardOpen}
        handleOk={handleCardCancel}
        handleCancel={handleCardCancel}
        titleValue={titleValue}
        gst={gst}
        gstAmt={gstAmt}
        cGstRate={cGstRate}
        cGstAmt={cGstAmt}
        sGstRate={sGstRate}
        sGstAmt={sGstAmt}
        iGstRate={iGstRate}
        iGstAmt={iGstAmt}
        basicAmt={basicAmt}
        netAmt={netAmt}
        smCode={smCode}
      />
      <ModifyInvoiceNo
        modifyOpen={modifyOpen}
        setModifyOpen={setModifyOpen}
        handleOk={handleModifyOpen}
        handleCancel={handleModifyCancel}
        modifyCode={modifyCode}
        setModifyCode={setModifyCode}
        modifyDetAPI={modifyDetAPI}
        modifyMastAPI={modifyMastAPI}
        modifyOnlineAPI={modifyOnlineAPI}
        modifyOpeningLedgerAPI={modifyOpeningLedgerAPI}
        handleRest={handleRest}
        tagNoRef={tagNoRef}
      />
      <CashMethod
        cashOpen={cashOpen}
        setCashOpen={setCashOpen}
        handleOk={handleCashOpen}
        handleCancel={handleCashCancel}
        cashValue={cashValue}
        setCashValue={setCashValue}
        totalNetAmt={totalNetAmt}
        cashAmt={cashAmt}
        setCashAmt={setCashAmt}
        cardAmt={cardAmt}
        setCardAmt={setCardAmt}
        upiAmt={upiAmt}
        setUpiAmt={setUpiAmt}
        onlineAmt={onlineAmt}
        setOnlineAmt={setOnlineAmt}
        creditAmt={creditAmt}
        setCreditAmt={setCreditAmt}
        setSwitchCredit={setSwitchCredit}
        switchCredit={switchCredit}
        creditCashValue={creditCashValue}
        setCreditCashValue={setCreditCashValue}
        creditCashAmt={creditCashAmt}
        setCreditCashAmt={setCreditCashAmt}
        creditCardAmt={creditCardAmt}
        setCreditCardAmt={setCreditCardAmt}
        creditUpiAmt={creditUpiAmt}
        setCreditUpiAmt={setCreditUpiAmt}
        creditOnlineAmt={creditOnlineAmt}
        setCreditOnlineAmt={setCreditOnlineAmt}
      />
      <WhatsAppDialog
        whatsAppOpen={whatsAppOpen}
        handleWhatsAppCancel={handleWhatsAppCancel}
        whatsAppCheck={whatsAppCheck}
        setWhatsAppCheck={setWhatsAppCheck}
      />
      <HomeBillDialog
        homeDetailsOpen={homeDetailsOpen}
        setHomeDetailsOpen={setHomeDetailsOpen}
        qty={qty}
        setQty={setQty}
        amount={amount}
        setAmount={setAmount}
        disCount={disCount}
        setDisCount={setDisCount}
        rate={rate}
        setRate={setRate}
        disAmt={disAmt}
        setDisAmt={setDisAmt}
        productName={productName}
        setProductName={setProductName}
        designCode={designCode}
        setDesignCode={setDesignCode}
        setPTypeName={setPTypeName}
        setHsnCode={setHsnCode}
        productData={productData}
        setProductData={setProductData}
        setBrandName={setBrandName}
        handleHomeBillSave={handleHomeBillSave}
      />
      <TaansDetailsDialog
        taansOpen={taansOpen}
        setTaansOpen={setTaansOpen}
        taansData={taansData}
        setTaansData={setTaansData}
        handleTaansBillSave={handleTaansBillSave}
      />
      <OfferDetailsADialog
        taansOpen={offerAOpen}
        setTaansOpen={setOfferAOpen}
        taansData={offerAData}
        setTaansData={setOfferAData}
        handleTaansBillSave={handleOfferABillSave}
        offerARate={offerARate}
      />
      <OfferDetailsBDialog
        taansOpen={offerBOpen}
        setTaansOpen={setOfferBOpen}
        taansData={offerBData}
        setTaansData={setOfferBData}
        handleTaansBillSave={handleOfferBBillSave}
        offerARate={offerBRate}
      />
      <EditItemDetails
        itemDetailsOpen={itemDetailsOpen}
        setItemDetailsOpen={setItemDetailsOpen}
        setItemDetailsData={setItemDetailsData}
        itemDetailsData={itemDetailsData}
        itemDesignCode={itemDesignCode}
        setBarCodeData={setBarCodeData}
        barCodeData={barCodeData}
        qtyData={qtyData}
        offerARate={offerARate}
        offerBRate={offerBRate}
      />
      {/* <div style="flex: 1; gap: 5px;  padding: 3px;">
          <div style="margin-bottom: 3px"><strong>USER:</strong> ${userName}</div>
          <div style="margin-bottom: 3px"><strong>DATE:</strong> ${dayjs().format("DD-MMM-YYYY")}</div>
          <div style="margin-bottom: 3px"><strong>TIME:</strong> ${dayjs().format("hh:mm A")}</div>
        </div> */}
    </div>
  );
};

export default BarCodeScanner;
